import { useEffect, useRef, useState } from 'react';
import './RefSystem.css';

const PUBLIC_VIEWS = ['home', 'about', 'events', 'contact', 'adhesion'];

const PLANS = [
  { id: 'po1', price: 30, name: 'Adhésion individuelle', formule: 'Individuelle', desc: '1 personne · Accès complet' },
  { id: 'po2', price: 50, name: 'Adhésion duo',          formule: 'Duo',          desc: '2 personnes · Accès complet' },
  { id: 'po3', price: 80, name: 'Adhésion entreprise',   formule: 'Entreprise',   desc: "Jusqu'à 5 personnes" },
];

const FEATURES = [
  { ico: '📱', t: 'App mobile iOS & Android', d: 'Accédez à votre réseau depuis votre téléphone. Messages, agenda, carte membre NFC.', bg: 'var(--cyan-soft)', bd: 'var(--cyan-border)' },
  { ico: '💳', t: 'Cotisation en ligne', d: 'Payez en 1, 2 ou 3 fois par carte. Reçu automatique. Renouvellement en un clic.', bg: 'rgba(124,92,252,0.1)', bd: 'rgba(124,92,252,0.2)' },
  { ico: '📅', t: 'Événements & Agenda', d: 'Inscriptions en ligne, rappels automatiques, check-in QR code sur place.', bg: 'rgba(255,173,77,0.1)', bd: 'rgba(255,173,77,0.2)' },
  { ico: '🤝', t: 'Networking intelligent', d: 'Carte de visite digitale NFC. Suivi des invitations. Recommandations business.', bg: 'var(--cyan-soft)', bd: 'var(--cyan-border)' },
  { ico: '💬', t: 'Messagerie & Projets', d: 'Échangez en privé. Collaborez sur des projets. Boîte à idées collective.', bg: 'rgba(79,138,255,0.1)', bd: 'rgba(79,138,255,0.2)' },
  { ico: '🔒', t: 'Sécurisé & RGPD', d: 'Données hébergées en France. Accès contrôlé par rôle. Chiffrement E2E.', bg: 'rgba(255,92,106,0.1)', bd: 'rgba(255,92,106,0.2)' },
];

const EVENTS = [
  { d: 15, m: 'Juin', n: 'Petit-déjeuner Entrepreneurs', meta: '📍 Hôtel Mercure Lyon · 8h00 → 10h00 · Gratuit membres', cur: 32, max: 50, status: 'ok' },
  { d: 22, m: 'Juin', n: 'Soirée Networking Business', meta: '📍 Le Roof Lyon · 19h00 → 22h00 · Membres + invités', cur: 78, max: 80, status: 'warn' },
  { d: 5,  m: 'Jul',  n: 'Atelier "Lever des fonds 2024"', meta: '📍 REF HQ · 14h00 → 17h00 · Membres uniquement', cur: 14, max: 30, status: 'ok' },
  { d: 19, m: 'Jul',  n: 'Assemblée Générale 2024', meta: '📍 Salle Confluence · 18h00 → 21h00 · Tous membres', cur: 45, max: 120, status: 'ok' },
  { d: 12, m: 'Sep',  n: 'Rentrée REF — Grand networking', meta: '📍 Villa Florentine · 18h30 → 23h00', cur: 12, max: 100, status: 'ok' },
  { d: 8,  m: 'Oct',  n: 'Atelier "IA pour entrepreneurs"', meta: '📍 REF HQ · 9h00 → 12h00 · Gratuit membres', cur: 8, max: 25, status: 'ok' },
];

const TESTIMONIALS = [
  { txt: '"3 partenaires commerciaux trouvés en 6 mois. La qualité des échanges est incomparable."', who: 'Jean Martin', role: 'CEO — Digital Agency', ini: 'JM', bg: 'var(--cyan)', col: '#060a09' },
  { txt: '"L\'app est super fluide. Je gère tout depuis mon téléphone, c\'est vraiment professionnel."', who: 'Sophie Bernard', role: 'Consultante RH', ini: 'SB', bg: 'var(--purple)', col: 'white' },
  { txt: '"En 1 an j\'ai une vraie communauté autour de moi. Des gens qui m\'aident à prendre les bonnes décisions."', who: 'Pierre Durand', role: 'Architecte indépendant', ini: 'PD', bg: 'var(--orange)', col: '#060a09' },
];

const VALUES = [
  { i: '🤝', t: "L'échange",    d: 'Partager ses expériences, ses erreurs, ses succès.' },
  { i: '🌱', t: 'La croissance', d: 'Grandir ensemble. Chaque membre contribue aux autres.' },
  { i: '🔒', t: 'La confiance',  d: 'Un espace sûr où la parole est libre.' },
  { i: '⚡', t: "L'action",      d: 'Des idées qui deviennent des projets concrets.' },
];

const BUREAU = [
  { ini: 'MD', n: 'Marie Dupont',   role: 'Présidente',          d: 'Entrepreneur depuis 12 ans, Marie a cofondé le REF pour créer le réseau qu\'elle aurait aimé avoir à ses débuts.', bg: 'var(--cyan)', col: '#060a09' },
  { ini: 'SB', n: 'Sophie Bernard', role: 'Secrétaire Générale', d: 'Consultante RH, Sophie orchestre la vie administrative du réseau.', bg: 'var(--purple)', col: 'white' },
  { ini: 'JM', n: 'Jean Martin',    role: 'Trésorier',           d: "CEO d'une agence digitale, Jean assure la solidité financière du réseau.", bg: 'var(--orange)', col: '#060a09' },
];

const COLOR_SWATCHES = ['#4DFFD2', '#4f8aff', '#7c5cfc', '#ffad4d', '#ff5c6a', '#ec4899', '#f59e0b', '#06b6d4'];

export default function RefSystem() {
  const [view, setView] = useState('home');
  const [activeLink, setActiveLink] = useState('home');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [toasts, setToasts] = useState([]);

  // Modals
  const [loginOpen, setLoginOpen] = useState(false);
  const [successOpen, setSuccessOpen] = useState(false);
  const [newAssoOpen, setNewAssoOpen] = useState(false);
  const [loginEmail, setLoginEmail] = useState('');
  const [loginPwd, setLoginPwd] = useState('');

  // Adhesion
  const [adhPrenom, setAdhPrenom] = useState('');
  const [adhNom, setAdhNom] = useState('');
  const [adhEmail, setAdhEmail] = useState('');
  const [planId, setPlanId] = useState('po1');
  const [installments, setInstallments] = useState(1);
  const [paying, setPaying] = useState(false);

  // Sidebar sections
  const [memberSec, setMemberSec] = useState('home');
  const [adminSec, setAdminSec] = useState('dash');
  const [saSec, setSaSec] = useState('overview');

  // Brand & live state
  const [brand, setBrand] = useState('#4DFFD2');
  const [identite, setIdentite] = useState({
    nom: "REF — Réseau d'Entrepreneurs Fugakwa",
    slogan: 'Construisons ensemble un réseau puissant',
    desc: 'Le REF connecte les entrepreneurs qui veulent échanger et grandir ensemble.',
  });
  const [memberCount, setMemberCount] = useState(247);
  const [pendingCount, setPendingCount] = useState(14);
  const [assoCount, setAssoCount] = useState(12);
  const [mrr, setMrr] = useState(540);
  const [newAssoName, setNewAssoName] = useState('');

  // Relances toggles
  const [relTog, setRelTog] = useState({ r30: true, r15: true, r7: true, sign: true, monthly: false });
  // IA agents toggles
  const [iaTog, setIaTog] = useState({ relances: true, compta: true, asso: true, com: true });

  const wrapperRef = useRef(null);
  const inFlight = useRef(0);
  const toastIdRef = useRef(0);

  // Inject Google Fonts once
  useEffect(() => {
    const id = 'refsys-fonts';
    if (!document.getElementById(id)) {
      const link = document.createElement('link');
      link.id = id;
      link.rel = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?family=Caveat:wght@600;700&family=Fraunces:ital,wght@0,700;0,900;1,700&family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap';
      document.head.appendChild(link);
    }
  }, []);

  // Live simulation
  useEffect(() => {
    const t = setInterval(() => {
      if (Math.random() > 0.96) {
        setMemberCount((c) => {
          const next = c + 1;
          toast('🎉 Nouveau membre vient de rejoindre le réseau !');
          return next;
        });
      }
    }, 9000);
    return () => clearInterval(t);
  }, []);

  // Scoped CSS variables for brand color
  const rgb = (() => {
    const r = parseInt(brand.slice(1, 3), 16);
    const g = parseInt(brand.slice(3, 5), 16);
    const b = parseInt(brand.slice(5, 7), 16);
    return `${r},${g},${b}`;
  })();
  const rootStyle = {
    '--cyan': brand,
    '--cyan-soft': `rgba(${rgb},0.09)`,
    '--cyan-border': `rgba(${rgb},0.2)`,
  };

  const toast = (msg, duration = 3000) => {
    const id = ++toastIdRef.current;
    setToasts((arr) => [...arr, { id, msg, show: false }]);
    requestAnimationFrame(() => requestAnimationFrame(() => {
      setToasts((arr) => arr.map((t) => t.id === id ? { ...t, show: true } : t));
    }));
    setTimeout(() => {
      setToasts((arr) => arr.map((t) => t.id === id ? { ...t, show: false } : t));
      setTimeout(() => setToasts((arr) => arr.filter((t) => t.id !== id)), 400);
    }, duration);
  };

  const goView = (v) => { setView(v); setMobileOpen(false); window.scrollTo(0, 0); };
  const navTo = (page) => { setActiveLink(page); goView(page); };

  const doLogin = (forcedEmail) => {
    const email = forcedEmail || loginEmail;
    setLoginOpen(false);
    if (email.includes('super')) { goView('superadmin'); toast('✅ Connecté en tant que Super Admin'); }
    else if (email.includes('admin')) { goView('admin'); toast('✅ Connecté — Back-office admin'); }
    else { goView('membre'); toast('✅ Bienvenue Marie ! Espace membre chargé.'); }
    setLoginEmail(''); setLoginPwd('');
  };

  // Adhesion calculations
  const currentPlan = PLANS.find((p) => p.id === planId) || PLANS[0];
  const price = currentPlan.price;
  const ht = (price / 1.2).toFixed(2);
  const tva = (price - ht).toFixed(2);
  const versementText = installments === 1 ? `1 × ${price}€` : `${installments} × ${(price / installments).toFixed(2)}€`;

  const payNow = () => {
    if (!adhPrenom || !adhNom || !adhEmail) { toast('⚠️ Merci de remplir au moins prénom, nom et email'); return; }
    setPaying(true);
    setTimeout(() => {
      setPaying(false);
      setMemberCount((c) => c + 1);
      setSuccessOpen(true);
    }, 1500);
  };

  const validerMembre = (e) => {
    const btn = e.currentTarget;
    btn.disabled = true;
    setTimeout(() => {
      setMemberCount((c) => c + 1);
      setPendingCount((p) => Math.max(0, p - 1));
      toast('✅ Membre validé ! Email de bienvenue envoyé.');
    }, 600);
  };

  const inscrireEv = (e) => {
    const btn = e.currentTarget;
    btn.disabled = true;
    btn.textContent = '✓ Inscrit';
    btn.className = 'btn btn-ghost btn-sm';
    toast("✅ Inscription confirmée ! Rappel 48h avant l'événement.");
  };

  const createAsso = () => {
    if (!newAssoName) { toast("⚠️ Entrez un nom pour l'association"); return; }
    setNewAssoOpen(false);
    setAssoCount((c) => c + 1);
    setMrr((m) => m + 45);
    toast(`🎉 "${newAssoName}" créée ! Email d'invitation envoyé.`);
    setNewAssoName('');
  };

  const isPublic = PUBLIC_VIEWS.includes(view);

  return (
    <div className="refsys" ref={wrapperRef} style={rootStyle} data-testid="refsys-root">
      {/* Toasts */}
      <div className="toast-wrap">
        {toasts.map((t) => (
          <div key={t.id} className={`toast ${t.show ? 'show' : ''}`}>{t.msg}</div>
        ))}
      </div>

      {/* Modal Login */}
      <div className={`modal-bg ${loginOpen ? 'open' : ''}`} onClick={(e) => e.target.classList.contains('modal-bg') && setLoginOpen(false)}>
        <div className="modal">
          <div className="modal-title">Connexion</div>
          <div className="modal-sub">Accédez à votre espace membre ou administrateur</div>
          <div className="fg"><label className="fl">Email</label><input className="fi" type="email" placeholder="votre@email.fr" value={loginEmail} onChange={(e) => setLoginEmail(e.target.value)} /></div>
          <div className="fg"><label className="fl">Mot de passe</label><input className="fi" type="password" placeholder="••••••••" value={loginPwd} onChange={(e) => setLoginPwd(e.target.value)} /></div>
          <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
            <button className="btn btn-ghost" style={{ flex: 1 }} onClick={() => setLoginOpen(false)}>Annuler</button>
            <button className="btn btn-primary" style={{ flex: 2 }} onClick={() => doLogin()}>Se connecter →</button>
          </div>
          <div style={{ textAlign: 'center', marginTop: 14, fontSize: 12, color: 'var(--muted)' }}>
            Pas encore membre ? <span style={{ color: 'var(--cyan)', cursor: 'pointer', fontWeight: 600 }} onClick={() => { setLoginOpen(false); goView('adhesion'); }}>Adhérer →</span>
          </div>
          <div style={{ marginTop: 12, padding: 10, background: 'var(--surface2)', borderRadius: 8, fontSize: 11, color: 'var(--muted)' }}>
            <strong style={{ color: 'var(--text)' }}>Comptes de test :</strong><br />
            admin@ref.fr → Back-office admin<br />
            super@ref.fr → Super admin<br />
            membre@ref.fr → Espace membre
          </div>
        </div>
      </div>

      {/* Modal Success Adhesion */}
      <div className={`modal-bg ${successOpen ? 'open' : ''}`} onClick={(e) => e.target.classList.contains('modal-bg') && setSuccessOpen(false)}>
        <div className="modal" style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 52, marginBottom: 14 }}>🎉</div>
          <div className="modal-title">Bienvenue dans le REF !</div>
          <div className="modal-sub">Votre adhésion est validée. Email de confirmation envoyé avec votre carte membre digitale.</div>
          <button className="btn btn-primary btn-full btn-lg" onClick={() => { setSuccessOpen(false); doLogin('membre@ref.fr'); }}>Accéder à mon espace →</button>
        </div>
      </div>

      {/* Modal Nouvelle Asso */}
      <div className={`modal-bg ${newAssoOpen ? 'open' : ''}`} onClick={(e) => e.target.classList.contains('modal-bg') && setNewAssoOpen(false)}>
        <div className="modal">
          <div className="modal-title">➕ Nouvelle association</div>
          <div className="modal-sub">Elle recevra un email d'invitation pour configurer son espace</div>
          <div className="fg"><label className="fl">Nom</label><input className="fi" placeholder="Ex: Club Rugby Figeac" value={newAssoName} onChange={(e) => setNewAssoName(e.target.value)} /></div>
          <div className="fg"><label className="fl">Type</label>
            <select className="fi"><option>🏛️ Réseau professionnel</option><option>⚽ Club sportif</option><option>🎭 Association culturelle</option><option>🏥 Association caritative</option></select>
          </div>
          <div className="fg"><label className="fl">Email admin</label><input className="fi" type="email" placeholder="admin@association.fr" /></div>
          <div className="fg"><label className="fl">Plan</label>
            <select className="fi" defaultValue="Pro — 45€/mois"><option>Starter — 20€/mois</option><option>Pro — 45€/mois</option><option>Network — 90€/mois</option></select>
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
            <button className="btn btn-ghost" style={{ flex: 1 }} onClick={() => setNewAssoOpen(false)}>Annuler</button>
            <button className="btn btn-primary" style={{ flex: 2 }} onClick={createAsso}>🚀 Créer</button>
          </div>
        </div>
      </div>

      {/* NAV PUBLIQUE */}
      {isPublic && (
        <>
          <nav className="gnav">
            <div className="gnav-logo" onClick={() => navTo('home')}>Ref</div>
            <div className="gnav-links">
              {[['home', 'Accueil'], ['about', 'Qui sommes-nous'], ['events', 'Rencontres'], ['contact', 'Contact']].map(([k, l]) => (
                <span key={k} className={`gnav-link ${activeLink === k ? 'act' : ''}`} onClick={() => navTo(k)}>{l}</span>
              ))}
            </div>
            <div className="gnav-right">
              <button className="btn btn-ghost btn-sm" onClick={() => setLoginOpen(true)} data-testid="login-btn">Connexion</button>
              <button className="btn btn-primary btn-sm" onClick={() => goView('adhesion')} data-testid="join-btn">Adhérer →</button>
            </div>
            <button className="ham" onClick={() => setMobileOpen((o) => !o)}><span /><span /><span /></button>
          </nav>
          <div className={`mobile-menu ${mobileOpen ? 'open' : ''}`}>
            {[['home', 'Accueil'], ['about', 'Qui sommes-nous'], ['events', 'Rencontres'], ['contact', 'Contact']].map(([k, l]) => (
              <span key={k} className="gnav-link" onClick={() => navTo(k)}>{l}</span>
            ))}
            <button className="btn btn-primary btn-sm" onClick={() => goView('adhesion')}>Adhérer →</button>
          </div>
        </>
      )}

      {/* VIEW HOME */}
      <div className={`view ${view === 'home' ? 'active' : ''}`}>
        <section className="hero-section">
          <div className="hero-bg" />
          <div className="hero-grid" />
          <div className="hero-badge">🏛️ Réseau d'Entrepreneurs Fugakwa</div>
          <h1 className="hero-title">Construisons ensemble<br />un réseau <span className="ac">puissant</span></h1>
          <p className="hero-sub">Le REF connecte les entrepreneurs, dirigeants et professionnels qui veulent échanger, collaborer et grandir ensemble.</p>
          <div className="hero-btns">
            <button className="btn btn-primary btn-lg" onClick={() => goView('adhesion')} data-testid="hero-join">Rejoindre le REF →</button>
            <button className="btn btn-outline btn-lg" onClick={() => navTo('events')}>Voir les rencontres</button>
          </div>
          <div className="hero-stats">
            <div className="hs"><div className="hs-val">{memberCount}</div><div className="hs-lbl">Membres actifs</div></div>
            <div className="hs"><div className="hs-val">38</div><div className="hs-lbl">Rencontres / an</div></div>
            <div className="hs"><div className="hs-val">12+</div><div className="hs-lbl">Secteurs</div></div>
          </div>
        </section>

        <div className="sec-block alt">
          <div className="sec-inner">
            <div className="sec-label">La plateforme</div>
            <div className="sec-h">Tout ce dont votre réseau a besoin</div>
            <p className="sec-p">App mobile, espace web, comptabilité, événements — tout connecté et synchronisé en temps réel.</p>
            <div className="feat-grid">
              {FEATURES.map((f, i) => (
                <div className="feat-card" key={i}>
                  <div className="feat-icon" style={{ background: f.bg, border: `1px solid ${f.bd}` }}>{f.ico}</div>
                  <div className="feat-title">{f.t}</div>
                  <div className="feat-desc">{f.d}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="sec-block">
          <div className="sec-inner">
            <div className="sec-label">Agenda</div>
            <div className="sec-h">Prochaines rencontres</div>
            <p className="sec-p">Des moments pensés pour que vous rencontriez les bonnes personnes.</p>
            <div className="ev-list">
              {EVENTS.slice(0, 3).map((ev, i) => (
                <div key={i} className="ev-card" onClick={() => goView('adhesion')}>
                  <div className="ev-date"><div className="ev-day">{ev.d}</div><div className="ev-mon">{ev.m}</div></div>
                  <div className="ev-info"><div className="ev-name">{ev.n}</div><div className="ev-meta">{ev.meta}</div></div>
                  <div className="ev-spots"><strong>{ev.cur}/{ev.max}</strong><span className={`chip ${ev.status === 'warn' ? 'chip-warn' : 'chip-cyan'}`} style={{ fontSize: 9 }}>{ev.status === 'warn' ? 'Complet bientôt' : 'Ouvert'}</span></div>
                </div>
              ))}
            </div>
            <div style={{ textAlign: 'center', marginTop: 20 }}>
              <button className="btn btn-outline" onClick={() => navTo('events')}>Voir toutes les rencontres →</button>
            </div>
          </div>
        </div>

        <div className="sec-block alt">
          <div className="sec-inner">
            <div className="sec-label">Ils en parlent</div>
            <div className="sec-h">Ce que disent nos membres</div>
            <div className="g3" style={{ marginTop: 40 }}>
              {TESTIMONIALS.map((t, i) => (
                <div className="card" key={i}>
                  <div className="card-body">
                    <div style={{ color: 'var(--orange)', fontSize: 13, letterSpacing: 2, marginBottom: 10 }}>★★★★★</div>
                    <div style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.7, fontStyle: 'italic', marginBottom: 14 }}>{t.txt}</div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <div className="av" style={{ width: 32, height: 32, borderRadius: '50%', background: t.bg, fontSize: 11, color: t.col }}>{t.ini}</div>
                      <div><div style={{ fontSize: 12, fontWeight: 700 }}>{t.who}</div><div style={{ fontSize: 10, color: 'var(--muted)' }}>{t.role}</div></div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="cta-wrap">
          <div className="cta-inner">
            <div className="cta-title">Prêt à rejoindre le REF ?</div>
            <div className="cta-sub">Adhésion annuelle à partir de 30€. Accès immédiat à l'app, aux événements et à toute la communauté.</div>
            <button className="btn btn-primary btn-lg" onClick={() => goView('adhesion')}>Adhérer maintenant — 30€/an →</button>
          </div>
        </div>
        <Footer onNav={navTo} onJoin={() => goView('adhesion')} />
      </div>

      {/* VIEW ABOUT */}
      <div className={`view ${view === 'about' ? 'active' : ''}`}>
        <div style={{ paddingTop: 64 }}>
          <div className="sec-block" style={{ textAlign: 'center', background: 'linear-gradient(180deg,rgba(77,255,210,0.05),transparent)' }}>
            <div className="sec-label" style={{ display: 'inline-block' }}>Notre histoire</div>
            <div className="hero-title" style={{ fontSize: 'clamp(34px,5vw,62px)', margin: '10px 0 16px' }}>Le <span className="ac">REF</span>, c'est quoi ?</div>
            <p style={{ fontSize: 16, color: 'var(--muted)', maxWidth: 560, margin: '0 auto', lineHeight: 1.75 }}>Un réseau d'entrepreneurs bâti sur l'échange sincère, la collaboration et l'entraide.</p>
          </div>
          <div className="sec-block alt">
            <div className="sec-inner">
              <div className="g4">
                {VALUES.map((v, i) => (
                  <div className="card" key={i}><div className="card-body" style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: 32, marginBottom: 10 }}>{v.i}</div>
                    <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 6 }}>{v.t}</div>
                    <div style={{ fontSize: 12, color: 'var(--muted)', lineHeight: 1.6 }}>{v.d}</div>
                  </div></div>
                ))}
              </div>
              <div style={{ marginTop: 50 }}><div className="sec-label">L'équipe</div><div className="sec-h">Le bureau du REF</div></div>
              <div className="g3" style={{ marginTop: 28 }}>
                {BUREAU.map((b, i) => (
                  <div className="card" key={i}><div className="card-body" style={{ textAlign: 'center' }}>
                    <div className="av" style={{ width: 64, height: 64, borderRadius: 20, background: b.bg, fontSize: 22, margin: '0 auto 12px', color: b.col, boxShadow: i === 0 ? '0 0 20px rgba(77,255,210,0.2)' : 'none' }}>{b.ini}</div>
                    <div style={{ fontSize: 16, fontWeight: 800, marginBottom: 3 }}>{b.n}</div>
                    <div style={{ fontSize: 12, color: 'var(--cyan)', fontWeight: 600, marginBottom: 8 }}>{b.role}</div>
                    <div style={{ fontSize: 12, color: 'var(--muted)', lineHeight: 1.6 }}>{b.d}</div>
                  </div></div>
                ))}
              </div>
            </div>
          </div>
          <div className="cta-wrap"><div className="cta-inner"><div className="cta-title">Rejoignez l'aventure</div><div className="cta-sub">{memberCount} membres vous attendent.</div><button className="btn btn-primary btn-lg" onClick={() => goView('adhesion')}>Adhérer maintenant →</button></div></div>
          <Footer onNav={navTo} onJoin={() => goView('adhesion')} />
        </div>
      </div>

      {/* VIEW EVENTS */}
      <div className={`view ${view === 'events' ? 'active' : ''}`}>
        <div style={{ paddingTop: 64 }}>
          <div className="sec-block" style={{ textAlign: 'center' }}>
            <div className="sec-label" style={{ display: 'inline-block' }}>Agenda 2024</div>
            <div className="hero-title" style={{ fontSize: 'clamp(34px,5vw,62px)', margin: '10px 0 16px' }}>Nos <span className="ac">rencontres</span></div>
            <p style={{ fontSize: 16, color: 'var(--muted)', maxWidth: 520, margin: '0 auto', lineHeight: 1.75 }}>Des moments pensés pour que vous rencontriez les bonnes personnes.</p>
          </div>
          <div className="sec-block alt">
            <div className="sec-inner">
              <div className="ev-list">
                {EVENTS.map((ev, i) => (
                  <div key={i} className="ev-card" onClick={() => goView('adhesion')}>
                    <div className="ev-date"><div className="ev-day">{ev.d}</div><div className="ev-mon">{ev.m}</div></div>
                    <div className="ev-info"><div className="ev-name">{ev.n}</div><div className="ev-meta">{ev.meta}</div></div>
                    <div className="ev-spots"><strong>{ev.cur}/{ev.max}</strong><span className={`chip ${ev.status === 'warn' ? 'chip-warn' : 'chip-cyan'}`} style={{ fontSize: 9 }}>{ev.status === 'warn' ? 'Bientôt complet' : 'Ouvert'}</span></div>
                  </div>
                ))}
              </div>
              <div style={{ textAlign: 'center', marginTop: 30, padding: 28, background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 16 }}>
                <div style={{ fontSize: 18, fontWeight: 800, marginBottom: 8 }}>Vous devez être membre pour vous inscrire</div>
                <div style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 18 }}>L'adhésion annuelle à 30€ donne accès à toutes les rencontres membres</div>
                <button className="btn btn-primary btn-lg" onClick={() => goView('adhesion')}>Adhérer maintenant — 30€/an →</button>
              </div>
            </div>
          </div>
          <Footer onNav={navTo} onJoin={() => goView('adhesion')} />
        </div>
      </div>

      {/* VIEW CONTACT */}
      <div className={`view ${view === 'contact' ? 'active' : ''}`}>
        <div style={{ paddingTop: 64 }}>
          <div className="sec-block" style={{ textAlign: 'center' }}>
            <div className="sec-label" style={{ display: 'inline-block' }}>Nous écrire</div>
            <div className="hero-title" style={{ fontSize: 'clamp(34px,5vw,62px)', margin: '10px 0 16px' }}>Prenons <span className="ac">contact</span></div>
          </div>
          <div className="sec-block alt">
            <div className="sec-inner">
              <div className="g2">
                <div className="card"><div className="card-body">
                  <div style={{ fontSize: 16, fontWeight: 800, marginBottom: 4 }}>Envoyez-nous un message</div>
                  <div style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 20 }}>Réponse sous 24h ouvrées</div>
                  <div className="g2"><div className="fg"><label className="fl">Prénom</label><input className="fi" placeholder="Votre prénom" /></div><div className="fg"><label className="fl">Nom</label><input className="fi" placeholder="Votre nom" /></div></div>
                  <div className="fg"><label className="fl">Email</label><input className="fi" type="email" placeholder="votre@email.fr" /></div>
                  <div className="fg"><label className="fl">Sujet</label><select className="fi"><option>Question sur l'adhésion</option><option>Informations sur les rencontres</option><option>Partenariat</option><option>Autre</option></select></div>
                  <div className="fg"><label className="fl">Message</label><textarea className="fi" rows="4" placeholder="Votre message..." /></div>
                  <button className="btn btn-primary btn-full" onClick={() => toast('✅ Message envoyé ! Réponse sous 24h.')}>Envoyer →</button>
                </div></div>
                <div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                    {[
                      ['📍', 'Adresse', 'Lyon, France'],
                      ['📧', 'Email', 'contact@ref-reseau.fr'],
                      ['📱', 'Téléphone', '+33 6 12 34 56 78'],
                    ].map(([i, l, v]) => (
                      <div key={l} style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                        <div style={{ width: 42, height: 42, borderRadius: 12, background: 'var(--cyan-soft)', border: '1px solid var(--cyan-border)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, flexShrink: 0 }}>{i}</div>
                        <div><div style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 2 }}>{l}</div><div style={{ fontSize: 14, fontWeight: 600 }}>{v}</div></div>
                      </div>
                    ))}
                    <div style={{ marginTop: 8, padding: 20, background: 'var(--surface)', border: '1px solid var(--cyan-border)', borderRadius: 14 }}>
                      <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 6 }}>Prêt à rejoindre ?</div>
                      <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 14 }}>Adhésion en ligne en 2 minutes.</div>
                      <button className="btn btn-primary btn-full" onClick={() => goView('adhesion')}>Adhérer →</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer onNav={navTo} onJoin={() => goView('adhesion')} />
        </div>
      </div>

      {/* VIEW ADHESION */}
      <div className={`view ${view === 'adhesion' ? 'active' : ''}`}>
        <div style={{ paddingTop: 64 }}>
          <div className="sec-block" style={{ textAlign: 'center', paddingBottom: 30 }}>
            <div className="sec-label" style={{ display: 'inline-block' }}>Rejoindre le REF</div>
            <div className="hero-title" style={{ fontSize: 'clamp(34px,5vw,58px)', margin: '10px 0 12px' }}>Votre <span className="ac">adhésion</span></div>
            <p style={{ fontSize: 14, color: 'var(--muted)' }}>Paiement sécurisé Stripe · Accès immédiat · RGPD conforme</p>
          </div>
          <div className="sec-block alt" style={{ paddingTop: 0 }}>
            <div className="sec-inner"><div className="g2">
              {/* FORM */}
              <div className="card">
                <div className="card-hdr"><div className="card-title">📝 Vos informations</div></div>
                <div className="card-body">
                  <div className="g2">
                    <div className="fg"><label className="fl">Prénom</label><input className="fi" placeholder="Marie" value={adhPrenom} onChange={(e) => setAdhPrenom(e.target.value)} data-testid="adh-prenom" /></div>
                    <div className="fg"><label className="fl">Nom</label><input className="fi" placeholder="Dupont" value={adhNom} onChange={(e) => setAdhNom(e.target.value)} data-testid="adh-nom" /></div>
                  </div>
                  <div className="fg"><label className="fl">Email professionnel</label><input className="fi" type="email" placeholder="marie@entreprise.fr" value={adhEmail} onChange={(e) => setAdhEmail(e.target.value)} data-testid="adh-email" /></div>
                  <div className="g2">
                    <div className="fg"><label className="fl">Téléphone</label><input className="fi" placeholder="06 12 34 56 78" /></div>
                    <div className="fg"><label className="fl">Secteur</label><select className="fi"><option value="">Choisir...</option><option>Digital & Tech</option><option>Commerce</option><option>Conseil</option><option>Immobilier</option><option>Santé</option><option>Finance</option><option>Autre</option></select></div>
                  </div>
                  <div className="fg"><label className="fl">Entreprise</label><input className="fi" placeholder="Mon Entreprise SAS" /></div>

                  <div className="fg" style={{ marginTop: 20 }}>
                    <label className="fl">Choisissez votre formule</label>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                      {PLANS.map((p) => {
                        const on = planId === p.id;
                        return (
                          <div key={p.id} onClick={() => setPlanId(p.id)} style={{ cursor: 'pointer' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '13px 14px', background: on ? 'var(--cyan-soft)' : 'var(--surface2)', border: `2px solid ${on ? 'var(--cyan)' : 'var(--border)'}`, borderRadius: 11 }}>
                              <div style={{ width: 16, height: 16, borderRadius: '50%', border: `2px solid ${on ? 'var(--cyan)' : 'var(--border)'}`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                {on && <div style={{ width: 8, height: 8, background: 'var(--cyan)', borderRadius: '50%' }} />}
                              </div>
                              <div style={{ flex: 1 }}><div style={{ fontSize: 13, fontWeight: 700 }}>{p.name}</div><div style={{ fontSize: 11, color: 'var(--muted)' }}>{p.desc}</div></div>
                              <div style={{ fontSize: 16, fontWeight: 800, color: on ? 'var(--cyan)' : 'var(--text)' }}>{p.price}€/an</div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  <div className="fg">
                    <label className="fl">Régler en</label>
                    <div style={{ display: 'flex', gap: 8 }}>
                      {[1, 2, 3].map((n) => (
                        <div key={n} onClick={() => setInstallments(n)} style={{
                          flex: 1, padding: 8, borderRadius: 8,
                          background: installments === n ? 'var(--cyan-soft)' : 'var(--surface2)',
                          border: `1px solid ${installments === n ? 'var(--cyan)' : 'var(--border)'}`,
                          color: installments === n ? 'var(--cyan)' : 'var(--muted)',
                          fontSize: 12, fontWeight: installments === n ? 700 : 600, textAlign: 'center', cursor: 'pointer',
                        }}>{n} fois</div>
                      ))}
                    </div>
                  </div>

                  <div className="fg"><label className="fl">Numéro de carte (Stripe)</label>
                    <div style={{ padding: '11px 13px', background: 'var(--surface2)', border: '1px solid var(--border)', borderRadius: 9, display: 'flex', alignItems: 'center', gap: 10 }}>
                      <span>🔒</span><span style={{ flex: 1, fontSize: 13, color: 'var(--muted)' }}>4242 4242 4242 4242</span>
                      <div style={{ display: 'flex', gap: 5 }}>
                        <div style={{ background: '#1434CB', color: 'white', fontSize: 8, fontWeight: 800, padding: '2px 6px', borderRadius: 4 }}>VISA</div>
                        <div style={{ background: '#EB001B', color: 'white', fontSize: 8, fontWeight: 800, padding: '2px 6px', borderRadius: 4 }}>MC</div>
                      </div>
                    </div>
                  </div>
                  <div className="g2">
                    <div className="fg"><label className="fl">Expiration</label><input className="fi" placeholder="MM / AA" /></div>
                    <div className="fg"><label className="fl">CVV</label><input className="fi" placeholder="123" /></div>
                  </div>

                  <button className="btn btn-primary btn-full btn-lg" onClick={payNow} disabled={paying} data-testid="pay-btn">
                    {paying ? '⏳ Traitement Stripe...' : <>🔒 Valider mon adhésion — {price}€</>}
                  </button>
                  <div style={{ textAlign: 'center', fontSize: 11, color: 'var(--muted)', marginTop: 10 }}>🔒 Paiement sécurisé Stripe · SSL · RGPD</div>
                </div>
              </div>

              {/* RÉSUMÉ */}
              <div>
                <div className="card" style={{ position: 'sticky', top: 80 }}>
                  <div className="card-hdr"><div className="card-title">🧾 Récapitulatif</div><span className="live-dot" /></div>
                  <div className="card-body">
                    <div style={{ fontFamily: "'Caveat', cursive", fontSize: 26, fontWeight: 700, color: 'var(--cyan)', marginBottom: 14 }}>Ref</div>
                    <div style={{ fontSize: 15, fontWeight: 800, marginBottom: 3 }}>{currentPlan.name}</div>
                    <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 18 }}>Réseau d'Entrepreneurs Fugakwa</div>
                    <div style={{ fontSize: 13 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid var(--border)' }}><span style={{ color: 'var(--muted)' }}>Formule</span><span style={{ fontWeight: 600 }}>{currentPlan.formule}</span></div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid var(--border)' }}><span style={{ color: 'var(--muted)' }}>Durée</span><span style={{ fontWeight: 600 }}>1 an</span></div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid var(--border)' }}><span style={{ color: 'var(--muted)' }}>Versements</span><span style={{ fontWeight: 600 }}>{versementText}</span></div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid var(--border)' }}><span style={{ color: 'var(--muted)' }}>Sous-total HT</span><span style={{ fontWeight: 600 }}>{ht}€</span></div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0' }}><span style={{ color: 'var(--muted)' }}>TVA 20%</span><span style={{ fontWeight: 600 }}>{tva}€</span></div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 0 0', borderTop: '1px solid var(--border)', fontSize: 15 }}><span style={{ fontWeight: 700 }}>Total TTC</span><span style={{ fontWeight: 800, color: 'var(--cyan)', fontSize: 18 }}>{price}€</span></div>
                    </div>
                    <div style={{ marginTop: 16, background: 'var(--surface2)', borderRadius: 11, padding: 13 }}>
                      <div style={{ fontSize: 10, fontWeight: 700, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 8 }}>Inclus dans votre adhésion</div>
                      <div style={{ fontSize: 12, color: 'var(--muted)' }}>
                        {['App mobile iOS & Android', 'Carte membre digitale NFC', 'Toutes les rencontres membres', 'Messagerie & Annuaire', 'Documents & Projets', 'Notifications push'].map((x, i) => (
                          <div key={i} style={{ padding: '3px 0' }}>✓ {x}</div>
                        ))}
                      </div>
                    </div>
                    <div style={{ marginTop: 12, padding: 11, background: 'var(--cyan-soft)', border: '1px solid var(--cyan-border)', borderRadius: 10, fontSize: 12, color: 'var(--muted)' }}>
                      🎯 <strong style={{ color: 'var(--text)' }}>{memberCount} membres</strong> vous attendent. Accès immédiat.
                    </div>
                  </div>
                </div>
              </div>
            </div></div>
          </div>
          <Footer onNav={navTo} onJoin={() => goView('adhesion')} />
        </div>
      </div>

      {/* VIEW MEMBRE */}
      {view === 'membre' && (
        <MemberView
          memberSec={memberSec} setMemberSec={setMemberSec}
          memberCount={memberCount} toast={toast}
          onLogout={() => goView('home')}
        />
      )}

      {/* VIEW ADMIN */}
      {view === 'admin' && (
        <AdminView
          adminSec={adminSec} setAdminSec={setAdminSec}
          memberCount={memberCount} pendingCount={pendingCount}
          identite={identite} setIdentite={setIdentite}
          brand={brand} setBrand={setBrand}
          relTog={relTog} setRelTog={setRelTog}
          validerMembre={validerMembre} toast={toast}
          onLogout={() => goView('home')}
        />
      )}

      {/* VIEW SUPER ADMIN */}
      {view === 'superadmin' && (
        <SuperAdminView
          saSec={saSec} setSaSec={setSaSec}
          assoCount={assoCount} mrr={mrr}
          iaTog={iaTog} setIaTog={setIaTog}
          toast={toast}
          onNewAsso={() => setNewAssoOpen(true)}
          onLogout={() => goView('home')}
        />
      )}
    </div>
  );
}

/* ─── Footer reusable ─── */
function Footer({ onNav, onJoin }) {
  return (
    <footer className="footer">
      <div className="footer-logo">Ref</div>
      <div className="footer-links">
        <span className="footer-link" onClick={() => onNav('home')}>Accueil</span>
        <span className="footer-link" onClick={() => onNav('about')}>Qui sommes-nous</span>
        <span className="footer-link" onClick={() => onNav('events')}>Rencontres</span>
        <span className="footer-link" onClick={onJoin}>Adhérer</span>
        <span className="footer-link" onClick={() => onNav('contact')}>Contact</span>
      </div>
      <div className="footer-copy">© 2024 REF — Réseau d'Entrepreneurs Fugakwa</div>
    </footer>
  );
}

/* ─── Member View ─── */
function MemberView({ memberSec, setMemberSec, memberCount, toast, onLogout }) {
  const titles = { home: 'Tableau de bord membre', events: 'Mes événements', messages: 'Messages', membres: 'Annuaire des membres', docs: 'Documents', projets: 'Projets', carte: 'Ma carte membre', paiements: 'Mes paiements' };
  const items = [
    { id: 'home', i: '🏠', l: 'Accueil' },
    { id: 'events', i: '📅', l: 'Événements', b: 3, bc: 'sb-badge-c' },
    { id: 'messages', i: '💬', l: 'Messages', b: 12, bc: 'sb-badge-o' },
    { id: 'membres', i: '👥', l: 'Annuaire' },
    { id: 'docs', i: '📁', l: 'Documents' },
    { id: 'projets', i: '📋', l: 'Projets' },
    { id: 'carte', i: '💳', l: 'Ma carte membre' },
    { id: 'paiements', i: '💰', l: 'Paiements' },
  ];

  return (
    <div className="view active">
      <div className="layout-sidebar">
        <aside className="sidebar">
          <div className="sb-hdr">
            <div className="sb-logo">Ref</div>
            <div className="sb-role">Espace Membre</div>
          </div>
          <div style={{ margin: '12px 10px 6px', background: 'var(--surface2)', border: '1px solid var(--border)', borderRadius: 9, padding: '10px 11px', display: 'flex', alignItems: 'center', gap: 9 }}>
            <div className="av" style={{ width: 28, height: 28, borderRadius: 8, background: 'var(--cyan)', fontSize: 11 }}>MD</div>
            <div><div style={{ fontSize: 12, fontWeight: 600 }}>Marie Dupont</div><div style={{ fontSize: 10, color: 'var(--muted)' }}>Membre actif · 2024</div></div>
          </div>
          <nav className="sb-nav">
            <div className="sb-sec">Menu</div>
            {items.map((it) => (
              <button key={it.id} className={`sb-item ${memberSec === it.id ? 'act' : ''}`} onClick={() => setMemberSec(it.id)} data-testid={`msb-${it.id}`}>
                <span className="sb-ic">{it.i}</span>{it.l}
                {it.b && <span className={`sb-badge ${it.bc}`}>{it.b}</span>}
              </button>
            ))}
          </nav>
          <div className="sb-footer">
            <div className="sb-user" onClick={onLogout}>
              <div className="sb-uav" style={{ background: 'var(--red)' }}>🚪</div>
              <div><div style={{ fontSize: 12, fontWeight: 600 }}>Se déconnecter</div><div style={{ fontSize: 10, color: 'var(--muted)' }}>Retour au site public</div></div>
            </div>
          </div>
        </aside>

        <div className="sb-main">
          <div className="topbar">
            <div className="topbar-info"><div className="t-title">{titles[memberSec]}</div><div className="t-sub">Bonjour Marie 👋 · <span style={{ color: 'var(--green)' }}>● Membre actif</span></div></div>
            <div className="topbar-right">
              <div style={{ fontSize: 12, color: 'var(--muted)', display: 'flex', alignItems: 'center', gap: 5 }}><span className="live-dot" /> Live</div>
              <button className="btn btn-ghost btn-sm" onClick={() => setMemberSec('carte')}>🎴 Ma carte</button>
            </div>
          </div>
          <div className="content">
            {memberSec === 'home' && (
              <>
                <div className="kpi-grid">
                  <div className="kpi"><div className="kpi-val" style={{ color: 'var(--cyan)' }}>{memberCount}</div><div className="kpi-lbl">Membres actifs</div><div className="kpi-trend trend-up">↑ +18 ce mois</div></div>
                  <div className="kpi"><div className="kpi-val" style={{ color: 'var(--green)' }}>8</div><div className="kpi-lbl">Événements à venir</div><div className="kpi-trend trend-up">↑ 3 nouveaux</div></div>
                  <div className="kpi"><div className="kpi-val" style={{ color: 'var(--orange)' }}>12</div><div className="kpi-lbl">Messages non lus</div><div className="kpi-trend" style={{ color: 'var(--muted)' }}>→ 3 conversations</div></div>
                  <div className="kpi"><div className="kpi-val" style={{ color: 'var(--purple)' }}>5</div><div className="kpi-lbl">Projets actifs</div><div className="kpi-trend trend-up">↑ 2 tâches</div></div>
                </div>
                <div className="g2">
                  <div className="card">
                    <div className="card-hdr"><div className="card-title">📅 Prochains événements</div><span className="chip chip-cyan" onClick={() => setMemberSec('events')} style={{ cursor: 'pointer' }}>Voir tout →</span></div>
                    <div style={{ padding: 0 }}>
                      {EVENTS.slice(0, 3).map((ev, i) => (
                        <div key={i} className="ev-card" style={{ borderRadius: 0, border: 'none', borderBottom: i < 2 ? '1px solid var(--border)' : 'none' }} onClick={() => setMemberSec('events')}>
                          <div className="ev-date"><div className="ev-day">{ev.d}</div><div className="ev-mon">{ev.m}</div></div>
                          <div className="ev-info"><div className="ev-name">{ev.n}</div><div className="ev-meta">{ev.meta.split('·')[0]}· {ev.meta.split('·')[1]}</div></div>
                          <div className="ev-spots"><strong>{ev.cur}/{ev.max}</strong></div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div>
                    <div className="card" style={{ marginBottom: 14 }}>
                      <div className="card-hdr"><div className="card-title">👥 Membres récents</div><span className="chip chip-cyan" onClick={() => setMemberSec('membres')} style={{ cursor: 'pointer' }}>Annuaire →</span></div>
                      <div style={{ padding: 0 }}>
                        {[['JM', 'Jean Martin', 'CEO · Digital Agency', 'var(--cyan)', '#060a09'], ['SB', 'Sophie Bernard', 'Consultante RH', 'var(--purple)', 'white'], ['AL', 'Alice Leroy', 'Architecte', 'var(--orange)', '#060a09']].map(([i, n, s, bg, c]) => (
                          <div key={n} className="m-row" style={{ padding: '11px 16px' }}>
                            <div className="m-av av" style={{ background: bg, fontSize: 11, borderRadius: 10, color: c }}>{i}</div>
                            <div className="m-info"><div className="m-name">{n}</div><div className="m-sub">{s}</div></div>
                            <div className="m-dot dot-on" />
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-hdr"><div className="card-title">🕐 Activité récente</div></div>
                      <div style={{ padding: 0 }}>
                        {[['✅', 'Jean Martin a payé sa cotisation (30€)', 'Il y a 12 min', 'var(--cyan-soft)'], ['👤', 'Alice Leroy a rejoint le réseau', 'Il y a 1h', 'rgba(79,138,255,0.1)'], ['📅', 'Nouvel événement : Atelier IA', 'Hier, 14h30', 'rgba(255,173,77,0.1)']].map(([i, t, when, bg], idx) => (
                          <div key={idx} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, padding: '11px 16px', borderBottom: idx < 2 ? '1px solid rgba(28,42,38,0.5)' : 'none' }}>
                            <div style={{ width: 30, height: 30, borderRadius: 8, background: bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, flexShrink: 0 }}>{i}</div>
                            <div><div style={{ fontSize: 12, fontWeight: 600 }}>{t}</div><div style={{ fontSize: 10, color: 'var(--muted)' }}>{when}</div></div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {memberSec === 'events' && (
              <>
                <div style={{ fontSize: 14, color: 'var(--muted)', marginBottom: 16 }}>Inscrivez-vous aux événements en un clic</div>
                <div className="ev-list">
                  {EVENTS.map((ev, i) => (
                    <div key={i} className="ev-card" style={{ cursor: 'default' }}>
                      <div className="ev-date"><div className="ev-day">{ev.d}</div><div className="ev-mon">{ev.m}</div></div>
                      <div className="ev-info"><div className="ev-name">{ev.n}</div><div className="ev-meta">{ev.meta}</div></div>
                      <div className="ev-spots"><strong>{ev.cur}/{ev.max}</strong></div>
                      <InscrireBtn toast={toast} />
                    </div>
                  ))}
                </div>
              </>
            )}

            {memberSec === 'messages' && (
              <div className="card">
                <div className="card-hdr"><div className="card-title">💬 Mes conversations</div><button className="btn btn-primary btn-sm" onClick={() => toast('Nouveau message — en cours de développement')}>✏️ Nouveau</button></div>
                <div style={{ padding: 0 }}>
                  {[
                    { ini: 'JM', n: 'Jean Martin', msg: "Tu as vu l'événement du 15 juin ?", t: '09:32', unread: 3, bg: 'var(--cyan)', col: '#060a09', online: true },
                    { ini: 'SB', n: 'Sophie Bernard', msg: 'Réunion bureau vendredi 18h ✅', t: 'Hier', bg: 'var(--purple)', col: 'white' },
                    { ini: 'AL', n: 'Alice Leroy', msg: 'Super initiative, je suis partante !', t: 'Lun', bg: 'var(--orange)', col: '#060a09' },
                  ].map((m, i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 11, padding: '13px 18px', borderBottom: i < 2 ? '1px solid rgba(28,42,38,0.6)' : 'none', cursor: 'pointer' }} onClick={() => toast('Conversation ouverte')}>
                      <div style={{ position: 'relative' }}>
                        <div className="av" style={{ width: 44, height: 44, borderRadius: 13, background: m.bg, fontSize: 14, color: m.col }}>{m.ini}</div>
                        {m.online && <div style={{ position: 'absolute', bottom: 1, right: 1, width: 10, height: 10, background: 'var(--cyan)', borderRadius: '50%', border: '2px solid var(--bg)' }} />}
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 3 }}><span style={{ fontSize: 13, fontWeight: 700 }}>{m.n}</span><span style={{ fontSize: 10, color: 'var(--muted)' }}>{m.t}</span></div>
                        <div style={{ fontSize: 12, color: 'var(--muted)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{m.msg}</div>
                      </div>
                      {m.unread && <div style={{ width: 18, height: 18, background: 'var(--cyan)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 9, fontWeight: 800, color: '#060a09' }}>{m.unread}</div>}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {memberSec === 'membres' && (
              <div className="card">
                <div className="card-hdr"><div className="card-title">👥 Annuaire des membres</div><span style={{ fontSize: 12, color: 'var(--muted)' }}>{memberCount} membres</span></div>
                <div className="card-body" style={{ paddingBottom: 0 }}><input className="fi" placeholder="🔍 Rechercher un membre..." style={{ marginBottom: 14 }} /></div>
                <div style={{ padding: 0 }}>
                  {[
                    ['JM', 'Jean Martin', 'CEO · Digital Agency · Lyon', 'var(--cyan)', '#060a09', 'on'],
                    ['SB', 'Sophie Bernard', 'Consultante RH · Paris', 'var(--purple)', 'white', 'on'],
                    ['PD', 'Pierre Durand', 'Architecte · Lyon', 'var(--orange)', '#060a09', 'pend'],
                    ['AL', 'Alice Leroy', 'Avocate · Bordeaux', 'var(--blue)', 'white', 'on'],
                    ['TM', 'Thomas Moreau', 'Entrepreneur · Nantes', 'var(--red)', 'white', 'off'],
                  ].map(([i, n, s, bg, c, dot], idx) => (
                    <div key={n} className="m-row" style={{ padding: '11px 18px', borderBottom: idx < 4 ? undefined : 'none' }}>
                      <div className="m-av av" style={{ background: bg, fontSize: 12, borderRadius: 11, color: c }}>{i}</div>
                      <div className="m-info"><div className="m-name">{n}</div><div className="m-sub">{s}</div></div>
                      <button className="btn btn-ghost btn-sm" onClick={() => toast(`Message envoyé à ${n}`)}>💬</button>
                      <div className={`m-dot dot-${dot}`} />
                    </div>
                  ))}
                </div>
              </div>
            )}

            {memberSec === 'docs' && (
              <div className="card">
                <div className="card-hdr"><div className="card-title">📁 Documents</div><button className="btn btn-primary btn-sm" onClick={() => toast('Document uploadé !')}>＋ Ajouter</button></div>
                <div style={{ padding: 0 }}>
                  {[
                    ['📄', 'Statuts association 2024.pdf', '12 jan. · Marie D. · 2,4 Mo', 'rgba(255,92,106,0.1)'],
                    ['📝', 'Règlement intérieur.docx', '5 jan. · Sophie B. · 890 Ko', 'rgba(79,138,255,0.1)'],
                    ['🖼️', 'Photos tournoi printemps.zip', '18 déc. · Jean M. · 14 Mo', 'rgba(34,211,160,0.1)'],
                  ].map(([i, n, m, bg], idx) => (
                    <div key={n} style={{ display: 'flex', alignItems: 'center', gap: 11, padding: '12px 18px', borderBottom: idx < 2 ? '1px solid rgba(28,42,38,0.5)' : 'none', cursor: 'pointer' }} onClick={() => toast('Téléchargement démarré')}>
                      <div style={{ width: 38, height: 38, borderRadius: 11, background: bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, flexShrink: 0 }}>{i}</div>
                      <div style={{ flex: 1 }}><div style={{ fontSize: 13, fontWeight: 600 }}>{n}</div><div style={{ fontSize: 11, color: 'var(--muted)' }}>{m}</div></div>
                      <button className="btn btn-ghost btn-sm">⬇️</button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {memberSec === 'projets' && (
              <div className="card">
                <div className="card-hdr"><div className="card-title">📋 Mes projets</div><button className="btn btn-primary btn-sm" onClick={() => toast('Nouveau projet créé !')}>＋ Créer</button></div>
                <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                  {[
                    ['Tournoi annuel 2024', 'Organisation logistique, inscriptions, récompenses.', 72, '5 tâches restantes', 'cyan'],
                    ['Refonte site web', 'Mise à jour du site public avec nouvelles couleurs.', 35, '11 tâches restantes', 'cyan'],
                    ['AG 2023 — Compte-rendu', 'Rédaction et diffusion du PV.', 100, '0 tâche', 'muted'],
                  ].map(([t, d, prog, tasks, chip]) => (
                    <div key={t} style={{ background: 'var(--surface2)', border: '1px solid var(--border)', borderRadius: 12, padding: 15 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                        <div style={{ fontSize: 14, fontWeight: 700 }}>{t}</div>
                        <span className={`chip chip-${chip}`}>{chip === 'muted' ? 'Terminé' : 'En cours'}</span>
                      </div>
                      <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 10 }}>{d}</div>
                      <div className="prog-bar"><div className="prog-fill" style={{ width: `${prog}%` }} /></div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: 'var(--muted)', marginTop: 5 }}><span>{prog}% complété</span><span>{tasks}</span></div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {memberSec === 'carte' && (
              <div style={{ maxWidth: 480, margin: '0 auto' }}>
                <div style={{ background: 'linear-gradient(135deg,#0d2420,#091a16)', border: '1px solid var(--cyan-border)', borderRadius: 20, padding: 24, position: 'relative', overflow: 'hidden', marginBottom: 16 }}>
                  <div style={{ position: 'absolute', top: -30, right: -30, width: 120, height: 120, background: 'radial-gradient(circle,rgba(77,255,210,0.1),transparent 70%)', borderRadius: '50%' }} />
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
                    <div style={{ fontFamily: "'Caveat', cursive", fontSize: 30, fontWeight: 700, color: 'var(--cyan)', textShadow: '0 0 14px rgba(77,255,210,0.3)' }}>Ref</div>
                    <span className="chip chip-cyan">Actif 2024</span>
                  </div>
                  <div style={{ fontSize: 20, fontWeight: 800, marginBottom: 3 }}>Marie Dupont</div>
                  <div style={{ fontFamily: 'monospace', fontSize: 12, color: 'var(--muted)', letterSpacing: '0.1em', marginBottom: 18 }}>ADH · 2024 · 0001</div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div><div style={{ fontSize: 10, color: 'var(--muted)' }}>Valide jusqu'au</div><div style={{ fontSize: 14, fontWeight: 700, color: 'var(--cyan)' }}>31 déc. 2024</div></div>
                    <div style={{ width: 48, height: 48, background: 'var(--cyan)', borderRadius: 11, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 26 }}>⬛</div>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 10, marginBottom: 16 }}>
                  <button className="btn btn-primary" style={{ flex: 1, justifyContent: 'center' }} onClick={() => toast('Carte partagée par NFC !')}>📡 Partager NFC</button>
                  <button className="btn btn-ghost" style={{ flex: 1, justifyContent: 'center' }} onClick={() => toast('Lien copié !')}>🔗 Copier lien</button>
                </div>
                <div className="card">
                  <div className="card-hdr"><div className="card-title">💳 Ma cotisation</div></div>
                  <div className="card-body" style={{ padding: 0 }}>
                    {[['Type', 'Adhésion individuelle', false], ['Montant', '30,00€', false], ['Date', '12 jan. 2024', false], ['Statut', null, true]].map(([k, v, isChip], i) => (
                      <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 16px', borderBottom: i < 3 ? '1px solid var(--border)' : 'none', fontSize: 13 }}>
                        <span style={{ color: 'var(--muted)' }}>{k}</span>
                        {isChip ? <span className="chip chip-ok">✓ À jour</span> : <span style={{ fontWeight: 700, color: k === 'Montant' ? 'var(--cyan)' : undefined }}>{v}</span>}
                      </div>
                    ))}
                  </div>
                </div>
                <button className="btn btn-outline btn-full" style={{ marginTop: 12 }} onClick={() => toast('Renouvellement 2025 — disponible en décembre')}>Renouveler pour 2025 →</button>
              </div>
            )}

            {memberSec === 'paiements' && (
              <div className="card">
                <div className="card-hdr"><div className="card-title">💰 Mes paiements</div><button className="btn btn-ghost btn-sm" onClick={() => toast('Export PDF généré !')}>📄 Export</button></div>
                <div className="card-body" style={{ padding: 0 }}>
                  <table>
                    <thead><tr><th>Description</th><th>Montant</th><th>Date</th><th>Statut</th></tr></thead>
                    <tbody>
                      <tr><td style={{ fontWeight: 600 }}>Cotisation individuelle 2024</td><td style={{ fontWeight: 700, color: 'var(--green)' }}>30€</td><td style={{ color: 'var(--muted)' }}>12 jan. 2024</td><td><span className="chip chip-ok">Payé</span></td></tr>
                      <tr><td style={{ fontWeight: 600 }}>Inscription tournoi printemps</td><td style={{ fontWeight: 700, color: 'var(--red)' }}>5€</td><td style={{ color: 'var(--muted)' }}>5 mar. 2024</td><td><span className="chip chip-ok">Payé</span></td></tr>
                      <tr><td style={{ fontWeight: 600 }}>Cotisation individuelle 2023</td><td style={{ fontWeight: 700, color: 'var(--green)' }}>25€</td><td style={{ color: 'var(--muted)' }}>8 fév. 2023</td><td><span className="chip chip-ok">Payé</span></td></tr>
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function InscrireBtn({ toast }) {
  const [inscrit, setInscrit] = useState(false);
  return (
    <button className={`btn ${inscrit ? 'btn-ghost' : 'btn-primary'} btn-sm`} disabled={inscrit} onClick={() => { setInscrit(true); toast("✅ Inscription confirmée ! Rappel 48h avant."); }}>
      {inscrit ? '✓ Inscrit' : "S'inscrire"}
    </button>
  );
}

/* ─── Admin View ─── */
function AdminView({ adminSec, setAdminSec, memberCount, pendingCount, identite, setIdentite, brand, setBrand, relTog, setRelTog, validerMembre, toast, onLogout }) {
  const titles = { dash: "Vue d'ensemble", membres: 'Gestion des membres', events: 'Événements', compta: 'Comptabilité', relances: 'Relances automatiques', identite: 'Identité & Marque', stripe: 'Stripe Connect', formules: 'Formules & Tarifs', site: 'Site public' };
  const items = [
    { sec: 'dash', i: '⊞', l: "Vue d'ensemble" },
    { sec: 'membres', i: '👥', l: 'Membres', b: memberCount, bc: 'sb-badge-c' },
    { sec: 'events', i: '📅', l: 'Événements' },
    { sec: 'compta', i: '📊', l: 'Comptabilité' },
    { sec: 'relances', i: '🔔', l: 'Relances auto' },
  ];
  const items2 = [
    { sec: 'identite', i: '🎨', l: 'Identité & Couleurs' },
    { sec: 'stripe', i: '💳', l: 'Stripe Connect' },
    { sec: 'formules', i: '📋', l: 'Formules & Tarifs' },
    { sec: 'site', i: '🌐', l: 'Site public' },
  ];
  const shortName = (identite.nom.split('—')[0] || 'REF').trim().split(' ').map((w) => w[0]).join('').slice(0, 3) || 'REF';

  return (
    <div className="view active">
      <div className="layout-sidebar">
        <aside className="sidebar">
          <div className="sb-hdr">
            <div className="sb-logo">{shortName}</div>
            <div className="sb-role">Administrateur</div>
          </div>
          <div style={{ margin: '12px 10px 6px', background: 'var(--surface2)', border: '1px solid var(--border)', borderRadius: 9, padding: '10px 11px', display: 'flex', alignItems: 'center', gap: 9 }}>
            <div className="av" style={{ width: 28, height: 28, borderRadius: 8, background: 'var(--cyan)', fontSize: 10 }}>SC</div>
            <div><div style={{ fontSize: 12, fontWeight: 600 }}>Sport & Culture Lyon</div><div style={{ fontSize: 10, color: 'var(--muted)' }}>Admin</div></div>
          </div>
          <nav className="sb-nav">
            <div className="sb-sec">Tableau de bord</div>
            {items.map((it) => (
              <button key={it.sec} className={`sb-item ${adminSec === it.sec ? 'act' : ''}`} onClick={() => setAdminSec(it.sec)}>
                <span className="sb-ic">{it.i}</span>{it.l}{it.b && <span className={`sb-badge ${it.bc}`}>{it.b}</span>}
              </button>
            ))}
            <div className="sb-sec">Configuration</div>
            {items2.map((it) => (
              <button key={it.sec} className={`sb-item ${adminSec === it.sec ? 'act' : ''}`} onClick={() => setAdminSec(it.sec)}>
                <span className="sb-ic">{it.i}</span>{it.l}
              </button>
            ))}
          </nav>
          <div className="sb-footer">
            <div className="sb-user" onClick={onLogout}>
              <div className="sb-uav" style={{ background: 'var(--red)' }}>🚪</div>
              <div><div style={{ fontSize: 12, fontWeight: 600 }}>Déconnexion</div><div style={{ fontSize: 10, color: 'var(--muted)' }}>Retour au site</div></div>
            </div>
          </div>
        </aside>

        <div className="sb-main">
          <div className="topbar">
            <div className="topbar-info"><div className="t-title">{titles[adminSec]}</div><div className="t-sub">Données en temps réel · <span style={{ color: 'var(--green)' }}>● Live</span></div></div>
            <div className="topbar-right">
              <button className="btn btn-ghost btn-sm" onClick={() => toast('Données actualisées !')}>🔄 Actualiser</button>
              <button className="btn btn-primary btn-sm" onClick={() => setAdminSec('identite')}>⚙️ Configurer</button>
            </div>
          </div>
          <div className="content">
            {adminSec === 'dash' && (
              <>
                <div className="kpi-grid">
                  <div className="kpi"><div className="kpi-val" style={{ color: 'var(--cyan)' }}>{memberCount}</div><div className="kpi-lbl">Membres actifs</div><div className="kpi-trend trend-up">↑ +18 ce mois</div></div>
                  <div className="kpi"><div className="kpi-val" style={{ color: 'var(--green)' }}>7 420€</div><div className="kpi-lbl">Cotisations 2024</div><div className="kpi-trend trend-up">↑ +12%</div></div>
                  <div className="kpi"><div className="kpi-val" style={{ color: 'var(--orange)' }}>{pendingCount}</div><div className="kpi-lbl">En attente validation</div><div className="kpi-trend trend-dn">↓ Action requise</div></div>
                  <div className="kpi"><div className="kpi-val" style={{ color: 'var(--red)' }}>8</div><div className="kpi-lbl">Cotisations expirées</div><div className="kpi-trend trend-dn">↓ Relances actives</div></div>
                </div>
                <div className="g2">
                  <div className="card">
                    <div className="card-hdr"><div className="card-title">👥 Derniers membres</div><span className="chip chip-cyan" onClick={() => setAdminSec('membres')} style={{ cursor: 'pointer' }}>Voir tous →</span></div>
                    <div style={{ padding: 0 }}>
                      {[
                        { ini: 'JM', n: 'Jean Martin', sub: 'Individuelle · Annuel · Actif', bg: 'var(--cyan)', col: '#060a09', status: 'ok' },
                        { ini: 'SB', n: 'Sophie Bernard', sub: 'Duo · Annuel · Actif', bg: 'var(--purple)', col: 'white', status: 'ok' },
                        { ini: 'PD', n: 'Pierre Durand', sub: 'Individuelle · En attente paiement', bg: 'var(--orange)', col: '#060a09', status: 'pend' },
                        { ini: 'TM', n: 'Thomas Moreau', sub: 'Individuelle · Expiré depuis 30j', bg: 'var(--red)', col: 'white', status: 'expired' },
                      ].map((m, i, arr) => (
                        <div key={m.n} className="m-row" style={{ padding: '11px 18px', borderBottom: i < arr.length - 1 ? undefined : 'none' }}>
                          <div className="m-av av" style={{ background: m.bg, fontSize: 11, borderRadius: 10, color: m.col }}>{m.ini}</div>
                          <div className="m-info"><div className="m-name">{m.n}</div><div className="m-sub">{m.sub}</div></div>
                          {m.status === 'ok' && <span className="chip chip-ok">Actif</span>}
                          {m.status === 'pend' && <div style={{ display: 'flex', gap: 4 }}>
                            <button className="btn btn-primary btn-sm" onClick={validerMembre}>✓ Valider</button>
                            <button className="btn btn-danger btn-sm" onClick={() => toast('Demande refusée')}>✗</button>
                          </div>}
                          {m.status === 'expired' && <button className="btn btn-ghost btn-sm" onClick={() => toast(`Relance envoyée à ${m.n}`)}>📧 Relancer</button>}
                        </div>
                      ))}
                    </div>
                  </div>
                  <div>
                    <div className="card" style={{ marginBottom: 14 }}>
                      <div className="card-hdr"><div className="card-title">📊 Revenus mensuels</div></div>
                      <div className="card-body">
                        <div style={{ display: 'flex', alignItems: 'flex-end', gap: 5, height: 60, marginBottom: 10 }}>
                          {[40, 55, 35, 70, 55, 90, 45].map((h, i) => (
                            <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
                              <div style={{ width: '100%', borderRadius: '3px 3px 0 0', background: 'var(--cyan)', opacity: i === 5 ? 1 : 0.7, height: `${h}%` }} />
                              <div style={{ fontSize: 9, color: 'var(--muted)' }}>{['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul'][i]}</div>
                            </div>
                          ))}
                        </div>
                        <div style={{ fontSize: 12 }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid var(--border)' }}><span style={{ color: 'var(--muted)' }}>Ce mois</span><span style={{ fontWeight: 700, color: 'var(--green)' }}>+1 240€</span></div>
                          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0' }}><span style={{ color: 'var(--muted)' }}>Total 2024</span><span style={{ fontWeight: 800, color: 'var(--cyan)' }}>7 420€</span></div>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-hdr"><div className="card-title">🔔 Relances en cours</div><span className="chip chip-ok">Agent IA actif</span></div>
                      <div className="card-body" style={{ padding: 0 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 16px', borderBottom: '1px solid rgba(28,42,38,0.5)' }}>
                          <div style={{ width: 28, height: 28, borderRadius: 8, background: 'rgba(255,92,106,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13 }}>📧</div>
                          <div style={{ flex: 1 }}><div style={{ fontSize: 12, fontWeight: 600 }}>Thomas Moreau — J+30</div><div style={{ fontSize: 10, color: 'var(--muted)' }}>3ème relance envoyée</div></div>
                          <span className="chip chip-err">Urgent</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 16px' }}>
                          <div style={{ width: 28, height: 28, borderRadius: 8, background: 'rgba(255,173,77,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13 }}>📧</div>
                          <div style={{ flex: 1 }}><div style={{ fontSize: 12, fontWeight: 600 }}>Alice Lambert — J-15</div><div style={{ fontSize: 10, color: 'var(--muted)' }}>Rappel automatique envoyé</div></div>
                          <span className="chip chip-warn">J-15</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {adminSec === 'membres' && (
              <>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                    <button className="btn btn-ghost btn-sm">Tous ({memberCount})</button>
                    <button className="btn btn-ghost btn-sm">Actifs (225)</button>
                    <button className="btn btn-ghost btn-sm">En attente ({pendingCount})</button>
                    <button className="btn btn-ghost btn-sm">Expirés (8)</button>
                  </div>
                  <button className="btn btn-primary btn-sm" onClick={() => toast('Invitation envoyée !')}>＋ Inviter</button>
                </div>
                <div className="card">
                  <div className="card-body" style={{ paddingBottom: 0 }}><input className="fi" placeholder="🔍 Rechercher..." style={{ marginBottom: 0 }} /></div>
                  <div className="tw">
                    <table>
                      <thead><tr><th>Membre</th><th>Formule</th><th>Fréquence</th><th>Expiration</th><th>Statut</th><th>Actions</th></tr></thead>
                      <tbody>
                        {[
                          ['JM', 'Jean Martin', 'jean@martin.fr', 'Individuelle', 'Annuel', '31 déc. 2024', 'ok', 'var(--cyan)', '#060a09'],
                          ['SB', 'Sophie Bernard', 'sophie@rh.fr', 'Duo', 'Annuel', '31 déc. 2024', 'ok', 'var(--purple)', 'white'],
                          ['PD', 'Pierre Durand', 'p.durand@archi.fr', 'Individuelle', 'Annuel', '—', 'pend', 'var(--orange)', '#060a09'],
                          ['TM', 'Thomas Moreau', 't.moreau@gmail.com', 'Individuelle', 'Annuel', '31 déc. 2023 ⚠️', 'expired', 'var(--red)', 'white'],
                        ].map(([i, n, e, f, fr, exp, st, bg, col]) => (
                          <tr key={n}>
                            <td><div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                              <div className="av" style={{ width: 28, height: 28, borderRadius: 8, background: bg, fontSize: 10, color: col }}>{i}</div>
                              <div><div style={{ fontWeight: 600 }}>{n}</div><div style={{ fontSize: 10, color: 'var(--muted)' }}>{e}</div></div>
                            </div></td>
                            <td>{f}</td><td>{fr}</td><td style={{ color: st === 'expired' ? 'var(--red)' : 'var(--muted)' }}>{exp}</td>
                            <td>{st === 'ok' && <span className="chip chip-ok">Actif</span>}{st === 'pend' && <span className="chip chip-warn">En attente</span>}{st === 'expired' && <span className="chip chip-err">Expiré</span>}</td>
                            <td>{st === 'pend' ? <div style={{ display: 'flex', gap: 4 }}><button className="btn btn-primary btn-sm" onClick={validerMembre}>✓ Valider</button><button className="btn btn-danger btn-sm" onClick={() => toast('Refusé')}>✗</button></div> : st === 'expired' ? <button className="btn btn-ghost btn-sm" onClick={() => toast('Relance envoyée !')}>📧 Relancer</button> : <button className="btn btn-ghost btn-sm" onClick={() => toast('Fiche ouverte')}>Voir</button>}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            )}

            {adminSec === 'compta' && (
              <>
                <div className="g2" style={{ marginBottom: 14 }}>
                  <div className="kpi" style={{ borderRadius: 14 }}><div className="kpi-val" style={{ color: 'var(--green)' }}>7 420€</div><div className="kpi-lbl">Revenus 2024</div><div className="kpi-trend trend-up">↑ +12%</div></div>
                  <div className="kpi" style={{ borderRadius: 14 }}><div className="kpi-val" style={{ color: 'var(--red)' }}>3 180€</div><div className="kpi-lbl">Dépenses 2024</div><div className="kpi-trend trend-up">↑ +5%</div></div>
                  <div className="kpi" style={{ borderRadius: 14 }}><div className="kpi-val" style={{ color: 'var(--cyan)' }}>4 240€</div><div className="kpi-lbl">Solde disponible</div><div className="kpi-trend" style={{ color: 'var(--muted)' }}>Exercice 2024</div></div>
                  <div className="kpi" style={{ borderRadius: 14 }}><div className="kpi-val" style={{ color: 'var(--orange)' }}>640€</div><div className="kpi-lbl">En attente</div><div className="kpi-trend" style={{ color: 'var(--muted)' }}>8 expirés</div></div>
                </div>
                <div className="card">
                  <div className="card-hdr"><div className="card-title">💰 Transactions</div><button className="btn btn-ghost btn-sm" onClick={() => toast('Export CSV généré !')}>Exporter CSV</button></div>
                  <div className="tw">
                    <table>
                      <thead><tr><th>Description</th><th>Type</th><th>Montant</th><th>Date</th><th>Statut</th></tr></thead>
                      <tbody>
                        <tr><td style={{ fontWeight: 600 }}>Jean Martin — Cotisation</td><td style={{ color: 'var(--muted)' }}>Cotisation</td><td style={{ fontWeight: 700, color: 'var(--green)' }}>+30€</td><td style={{ color: 'var(--muted)' }}>12 jan.</td><td><span className="chip chip-ok">Payé</span></td></tr>
                        <tr><td style={{ fontWeight: 600 }}>Location salle AG</td><td style={{ color: 'var(--muted)' }}>Dépense</td><td style={{ fontWeight: 700, color: 'var(--red)' }}>-250€</td><td style={{ color: 'var(--muted)' }}>10 jan.</td><td><span className="chip chip-ok">Payé</span></td></tr>
                        <tr><td style={{ fontWeight: 600 }}>Sophie Bernard — Cotisation duo</td><td style={{ color: 'var(--muted)' }}>Cotisation</td><td style={{ fontWeight: 700, color: 'var(--green)' }}>+50€</td><td style={{ color: 'var(--muted)' }}>15 jan.</td><td><span className="chip chip-ok">Payé</span></td></tr>
                        <tr><td style={{ fontWeight: 600 }}>Traiteur soirée</td><td style={{ color: 'var(--muted)' }}>Dépense</td><td style={{ fontWeight: 700, color: 'var(--red)' }}>-180€</td><td style={{ color: 'var(--muted)' }}>8 jan.</td><td><span className="chip chip-ok">Payé</span></td></tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            )}

            {adminSec === 'relances' && (
              <div className="card">
                <div className="card-hdr"><div className="card-title">🤖 Relances automatiques</div><span className="chip chip-ok">Agent IA actif</span></div>
                <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                  {[
                    { k: 'r30', i: '📧', bg: 'var(--cyan-soft)', t: 'Rappel J-30 avant expiration', d: 'Email amical avec lien de renouvellement' },
                    { k: 'r15', i: '📧', bg: 'rgba(255,173,77,0.1)', t: 'Rappel J-15 avant expiration', d: '2ème rappel avec paiement 1x/2x/3x proposé' },
                    { k: 'r7', i: '📧', bg: 'rgba(255,92,106,0.1)', t: 'Rappel J-7 avant expiration', d: "Dernier rappel urgent — ton adapté par l'IA" },
                    { k: 'sign', i: '🖊️', bg: 'rgba(255,92,106,0.1)', t: 'Courrier de démission signé', d: 'PDF généré + archivé automatiquement' },
                    { k: 'monthly', i: '📅', bg: 'rgba(107,152,136,0.1)', t: 'Relance mensuelle post-expiration', d: 'Email pendant 3 mois pour retour potentiel' },
                  ].map((r) => (
                    <div key={r.k} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: 12, background: 'var(--surface2)', borderRadius: 10 }}>
                      <div style={{ width: 34, height: 34, borderRadius: 9, background: r.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16 }}>{r.i}</div>
                      <div style={{ flex: 1 }}><div style={{ fontSize: 13, fontWeight: 700 }}>{r.t}</div><div style={{ fontSize: 11, color: 'var(--muted)' }}>{r.d}</div></div>
                      <button className={`toggle ${relTog[r.k] ? 'on' : 'off'}`} onClick={() => setRelTog((s) => ({ ...s, [r.k]: !s[r.k] }))} />
                    </div>
                  ))}
                </div>
              </div>
            )}

            {adminSec === 'identite' && (
              <div className="g2">
                <div>
                  <div className="card" style={{ marginBottom: 14 }}>
                    <div className="card-hdr"><div className="card-title">🏷️ Informations</div></div>
                    <div className="card-body">
                      <div className="fg"><label className="fl">Nom de l'association</label><input className="fi" value={identite.nom} onChange={(e) => setIdentite({ ...identite, nom: e.target.value })} /></div>
                      <div className="fg"><label className="fl">Slogan</label><input className="fi" value={identite.slogan} onChange={(e) => setIdentite({ ...identite, slogan: e.target.value })} /></div>
                      <div className="fg"><label className="fl">Description</label><textarea className="fi" value={identite.desc} onChange={(e) => setIdentite({ ...identite, desc: e.target.value })} /></div>
                      <div className="fg">
                        <label className="fl">Couleur principale</label>
                        <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 8 }}>
                          <input type="color" value={brand} onChange={(e) => setBrand(e.target.value)} style={{ width: 38, height: 38, borderRadius: 9, border: '2px solid var(--border)', cursor: 'pointer', background: 'none', padding: 2 }} />
                          <input className="fi" value={brand} onChange={(e) => /^#[0-9A-Fa-f]{0,6}$/.test(e.target.value) && setBrand(e.target.value)} style={{ fontFamily: 'monospace', flex: 1 }} />
                        </div>
                        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                          {COLOR_SWATCHES.map((c) => (
                            <div key={c} onClick={() => { setBrand(c); toast('🎨 Couleur appliquée'); }} style={{
                              width: 26, height: 26, borderRadius: 7, background: c, cursor: 'pointer',
                              border: `2px solid ${brand.toUpperCase() === c.toUpperCase() ? 'white' : 'transparent'}`,
                              transition: 'transform 0.15s',
                            }} />
                          ))}
                        </div>
                      </div>
                      <button className="btn btn-primary btn-full" onClick={() => toast('💾 Identité sauvegardée — Site mis à jour !')}>💾 Sauvegarder & Publier</button>
                    </div>
                  </div>
                </div>
                <div className="card" style={{ position: 'sticky', top: 80 }}>
                  <div className="card-hdr"><div className="card-title">👁️ Aperçu live</div><span style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 11, color: 'var(--green)' }}><span className="live-dot" /> Temps réel</span></div>
                  <div className="card-body" style={{ padding: 10 }}>
                    <div style={{ background: 'var(--surface2)', border: '1px solid var(--border)', borderRadius: 12, overflow: 'hidden' }}>
                      <div style={{ background: 'rgba(6,10,9,0.9)', padding: '7px 12px', display: 'flex', alignItems: 'center', gap: 7, borderBottom: '1px solid var(--border)' }}>
                        <div style={{ display: 'flex', gap: 4 }}>
                          <div style={{ width: 9, height: 9, borderRadius: '50%', background: '#ff5c6a' }} />
                          <div style={{ width: 9, height: 9, borderRadius: '50%', background: '#ffad4d' }} />
                          <div style={{ width: 9, height: 9, borderRadius: '50%', background: '#22d3a0' }} />
                        </div>
                        <div style={{ background: 'var(--surface)', borderRadius: 4, padding: '2px 10px', fontSize: 10, color: 'var(--muted)', flex: 1, textAlign: 'center' }}>ref-fugakwa.plateforme-ref.fr</div>
                      </div>
                      <div style={{ padding: '14px 14px 10px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14, paddingBottom: 10, borderBottom: '1px solid var(--border)' }}>
                          <div style={{ fontFamily: "'Caveat', cursive", fontSize: 20, fontWeight: 700, color: 'var(--cyan)' }}>{shortName}</div>
                          <div style={{ fontSize: 10, fontWeight: 700, padding: '4px 10px', borderRadius: 6, background: 'var(--cyan)', color: '#060a09' }}>Adhérer →</div>
                        </div>
                        <div style={{ textAlign: 'center', padding: '10px 0' }}>
                          <div style={{ fontSize: 15, fontWeight: 800, marginBottom: 6, lineHeight: 1.3 }}>{identite.slogan.slice(0, 55) || 'Votre slogan'}</div>
                          <div style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 12 }}>{identite.desc.slice(0, 80)}</div>
                          <div style={{ display: 'flex', justifyContent: 'center', gap: 18 }}>
                            <div style={{ textAlign: 'center' }}><div style={{ fontSize: 18, fontWeight: 800, color: 'var(--cyan)' }}>{memberCount}</div><div style={{ fontSize: 9, color: 'var(--muted)' }}>Membres</div></div>
                            <div style={{ textAlign: 'center' }}><div style={{ fontSize: 18, fontWeight: 800, color: 'var(--cyan)' }}>38</div><div style={{ fontSize: 9, color: 'var(--muted)' }}>Rencontres/an</div></div>
                            <div style={{ textAlign: 'center' }}><div style={{ fontSize: 18, fontWeight: 800, color: 'var(--cyan)' }}>12+</div><div style={{ fontSize: 9, color: 'var(--muted)' }}>Secteurs</div></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {adminSec === 'stripe' && (
              <div className="g2">
                <div className="card">
                  <div className="card-hdr"><div className="card-title">💳 Stripe Connect</div></div>
                  <div className="card-body">
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
                      <div style={{ width: 40, height: 40, background: '#635bff', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, color: 'white', fontSize: 18 }}>S</div>
                      <div><div style={{ fontSize: 14, fontWeight: 700 }}>Stripe Connect</div><div style={{ fontSize: 12, color: 'var(--muted)' }}>Paiements directs sur votre compte</div></div>
                    </div>
                    <span className="chip chip-warn" style={{ marginBottom: 14, display: 'inline-flex' }}>⏳ En cours de vérification</span>
                    <div style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 16, lineHeight: 1.7 }}>Avec Stripe Connect, chaque adhésion est versée <strong style={{ color: 'var(--text)' }}>directement sur votre compte bancaire</strong>. La plateforme prélève 2% + 0,30€/transaction.</div>
                    <button className="btn btn-primary btn-full" onClick={() => toast('Redirection vers Stripe Connect...')}>🔗 Connecter mon compte Stripe →</button>
                  </div>
                </div>
                <div className="card">
                  <div className="card-hdr"><div className="card-title">⚙️ Configuration paiement</div></div>
                  <div className="card-body">
                    <div className="fg"><label className="fl">IBAN</label><input className="fi" defaultValue="FR76 3000 6000 0112 3456 7890 189" style={{ fontFamily: 'monospace', fontSize: 12 }} /></div>
                    <div className="fg"><label className="fl">Devise</label><select className="fi"><option>EUR — Euro (€)</option><option>GBP — Livre sterling (£)</option><option>USD — Dollar ($)</option></select></div>
                    <div className="fg">
                      <label className="fl">Paiements fractionnés</label>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 12 }}><input type="checkbox" defaultChecked /> Paiement en 2 fois autorisé</label>
                        <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 12 }}><input type="checkbox" defaultChecked /> Paiement en 3 fois autorisé</label>
                        <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 12 }}><input type="checkbox" /> Frais de dossier pour fractionné</label>
                      </div>
                    </div>
                    <button className="btn btn-primary btn-full" onClick={() => toast('Configuration sauvegardée !')}>Sauvegarder</button>
                  </div>
                </div>
              </div>
            )}

            {adminSec === 'formules' && (
              <>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                  <div style={{ fontSize: 13, color: 'var(--muted)' }}>Configurez vos tarifs — chaque association choisit</div>
                  <button className="btn btn-primary btn-sm" onClick={() => toast('Nouvelle formule')}>＋ Nouvelle formule</button>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                  {[
                    { n: 'Adhésion individuelle', d: '1 personne · Accès complet · Annuel', p: 30, st: 'Actif', col: 'var(--cyan)', ok: true },
                    { n: 'Adhésion duo', d: '2 personnes · Accès complet · Annuel', p: 50, st: 'Actif', col: 'var(--cyan)', ok: true },
                    { n: 'Adhésion entreprise', d: '5 personnes · Accès complet · Annuel', p: 80, st: 'Actif', col: 'var(--cyan)', ok: true },
                    { n: 'Adhésion mensuelle', d: '1 personne · Sans engagement · Mensuel', p: 4, st: 'Brouillon', col: 'var(--muted)', ok: false },
                  ].map((f) => (
                    <div key={f.n} style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 12, padding: 16, display: 'flex', alignItems: 'center', gap: 14 }}>
                      <div style={{ width: 12, height: 40, borderRadius: 4, background: f.col, flexShrink: 0 }} />
                      <div style={{ flex: 1 }}><div style={{ fontSize: 14, fontWeight: 700 }}>{f.n}</div><div style={{ fontSize: 11, color: 'var(--muted)' }}>{f.d}</div></div>
                      <div style={{ textAlign: 'right' }}><div style={{ fontSize: 17, fontWeight: 800, color: f.ok ? 'var(--cyan)' : 'var(--text)' }}>{f.p}€</div><div style={{ fontSize: 10, color: 'var(--muted)' }}>{f.n.includes('mensuelle') ? 'par mois' : 'par an'}</div></div>
                      <span className={`chip ${f.ok ? 'chip-ok' : 'chip-muted'}`}>{f.st}</span>
                      <button className="btn btn-ghost btn-sm" onClick={() => toast('Formule en édition')}>✏️</button>
                    </div>
                  ))}
                </div>
              </>
            )}

            {adminSec === 'site' && (
              <div className="g2">
                <div className="card">
                  <div className="card-hdr"><div className="card-title">🌐 Domaine & URL</div></div>
                  <div className="card-body">
                    <div className="fg"><label className="fl">Sous-domaine</label><div style={{ display: 'flex', gap: 8, alignItems: 'center' }}><input className="fi" defaultValue="ref-fugakwa" style={{ flex: 1 }} /><span style={{ color: 'var(--muted)', fontSize: 12, whiteSpace: 'nowrap' }}>.plateforme-ref.fr</span></div></div>
                    <div className="fg"><label className="fl">Domaine personnalisé (optionnel)</label><input className="fi" placeholder="www.ref-reseau.fr" /></div>
                    <button className="btn btn-ghost btn-full" onClick={() => toast('Site public ouvert !')}>🔗 Voir mon site public →</button>
                  </div>
                </div>
                <div className="card">
                  <div className="card-hdr"><div className="card-title">📝 Contenu accueil</div></div>
                  <div className="card-body">
                    <div className="fg"><label className="fl">Titre principal</label><input className="fi" defaultValue="Construisons ensemble un réseau puissant" /></div>
                    <div className="fg"><label className="fl">Présentation</label><textarea className="fi" defaultValue="Le REF connecte les entrepreneurs, dirigeants et professionnels qui veulent échanger, collaborer et grandir ensemble." /></div>
                    <div className="fg"><label className="fl">Affichage compteur membres</label><select className="fi"><option>Nombre réel en temps réel</option><option>Arrondi "200+ membres"</option><option>Masqué</option></select></div>
                    <button className="btn btn-primary btn-full" onClick={() => toast('Site public mis à jour en temps réel !')}>💾 Mettre à jour</button>
                  </div>
                </div>
              </div>
            )}

            {adminSec === 'events' && (
              <div className="card">
                <div className="card-hdr"><div className="card-title">📅 Événements à gérer</div><button className="btn btn-primary btn-sm" onClick={() => toast('Création événement')}>＋ Créer</button></div>
                <div style={{ padding: 0 }}>
                  {EVENTS.slice(0, 4).map((ev, i, arr) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 18px', borderBottom: i < arr.length - 1 ? '1px solid rgba(28,42,38,0.5)' : 'none' }}>
                      <div className="ev-date"><div className="ev-day">{ev.d}</div><div className="ev-mon">{ev.m}</div></div>
                      <div style={{ flex: 1 }}><div style={{ fontSize: 13, fontWeight: 700 }}>{ev.n}</div><div style={{ fontSize: 11, color: 'var(--muted)' }}>{ev.meta}</div></div>
                      <span className="ev-spots"><strong>{ev.cur}/{ev.max}</strong></span>
                      <button className="btn btn-ghost btn-sm" onClick={() => toast('Édition événement')}>✏️</button>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

/* ─── Super Admin View ─── */
function SuperAdminView({ saSec, setSaSec, assoCount, mrr, iaTog, setIaTog, toast, onNewAsso, onLogout }) {
  const titles = { overview: 'Vue globale de la plateforme', assos: 'Associations', revenus: 'Revenus SaaS', alertes: 'Alertes', ia: 'Agents IA', params: 'Paramètres' };
  const items = [
    { sec: 'overview', i: '⊞', l: 'Vue globale' },
    { sec: 'assos', i: '🏛️', l: 'Associations', b: assoCount, bc: 'sb-badge-c' },
    { sec: 'revenus', i: '💰', l: 'Revenus SaaS' },
    { sec: 'alertes', i: '🔔', l: 'Alertes', b: 3, bc: 'sb-badge-r' },
  ];
  const items2 = [
    { sec: 'ia', i: '🤖', l: 'Agents IA' },
    { sec: 'params', i: '⚙️', l: 'Paramètres' },
  ];

  return (
    <div className="view active">
      <div className="layout-sidebar">
        <aside className="sidebar">
          <div className="sb-hdr">
            <div className="sb-logo">Ref</div>
            <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.07em', textTransform: 'uppercase', color: 'var(--muted)', background: 'rgba(255,92,106,0.1)', border: '1px solid rgba(255,92,106,0.2)', borderRadius: 4, padding: '2px 8px', display: 'inline-block', marginTop: 4 }}>Super Admin</div>
          </div>
          <nav className="sb-nav">
            <div className="sb-sec">Plateforme</div>
            {items.map((it) => (
              <button key={it.sec} className={`sb-item ${saSec === it.sec ? 'act' : ''}`} onClick={() => setSaSec(it.sec)}>
                <span className="sb-ic">{it.i}</span>{it.l}{it.b && <span className={`sb-badge ${it.bc}`}>{it.b}</span>}
              </button>
            ))}
            <div className="sb-sec">Gestion</div>
            {items2.map((it) => (
              <button key={it.sec} className={`sb-item ${saSec === it.sec ? 'act' : ''}`} onClick={() => setSaSec(it.sec)}>
                <span className="sb-ic">{it.i}</span>{it.l}
              </button>
            ))}
          </nav>
          <div className="sb-footer">
            <div className="sb-user" onClick={onLogout}>
              <div className="sb-uav" style={{ background: 'var(--red)' }}>🚪</div>
              <div><div style={{ fontSize: 12, fontWeight: 600 }}>Déconnexion</div></div>
            </div>
          </div>
        </aside>
        <div className="sb-main">
          <div className="topbar">
            <div className="topbar-info"><div className="t-title">{titles[saSec]}</div><div className="t-sub">{assoCount} associations · <span style={{ color: 'var(--green)' }}>● Tous systèmes opérationnels</span></div></div>
            <div className="topbar-right">
              <button className="btn btn-ghost btn-sm" onClick={() => toast('Rapport généré')}>📊 Rapport</button>
              <button className="btn btn-primary btn-sm" onClick={onNewAsso}>➕ Nouvelle asso</button>
            </div>
          </div>
          <div className="content">
            {saSec === 'overview' && (
              <>
                <div className="kpi-grid">
                  <div className="kpi"><div className="kpi-val" style={{ color: 'var(--cyan)' }}>{assoCount}</div><div className="kpi-lbl">Associations</div><div className="kpi-trend trend-up">↑ +2 ce mois</div></div>
                  <div className="kpi"><div className="kpi-val" style={{ color: 'var(--green)' }}>2 847</div><div className="kpi-lbl">Membres totaux</div><div className="kpi-trend trend-up">↑ +184</div></div>
                  <div className="kpi"><div className="kpi-val" style={{ color: 'var(--blue)' }}>{mrr}€</div><div className="kpi-lbl">MRR</div><div className="kpi-trend trend-up">↑ +90€</div></div>
                  <div className="kpi"><div className="kpi-val" style={{ color: 'var(--red)' }}>2</div><div className="kpi-lbl">Abonnements en retard</div><div className="kpi-trend trend-dn">↓ Action</div></div>
                </div>
                <div className="g2">
                  <div className="card">
                    <div className="card-hdr"><div className="card-title">🏛️ Associations</div><span className="chip chip-cyan" onClick={() => setSaSec('assos')} style={{ cursor: 'pointer' }}>Toutes →</span></div>
                    <div style={{ padding: 12, display: 'flex', flexDirection: 'column', gap: 8 }}>
                      {[
                        { ini: 'R', n: 'REF — Réseau Fugakwa', s: '🏛️ Réseau pro · Lyon · 247 membres', p: '45€/mois', st: 'ok', stl: 'Actif', bg: 'var(--cyan)', col: '#060a09' },
                        { ini: 'GF', n: 'Club Rugby Figeac', s: '⚽ Sport · Figeac · 89 membres', p: '20€/mois', st: 'ok', stl: 'Actif', bg: 'var(--blue)', col: 'white' },
                        { ini: 'CT', n: 'Cie Théâtre du Soleil', s: '🎭 Culture · Paris · 124 membres', p: '20€/mois', st: 'warn', stl: 'Config incomplète', bg: 'var(--orange)', col: '#060a09' },
                        { ini: 'AS', n: 'Asso Solidarité Cancer', s: '🏥 Caritatif · Bordeaux · 312 membres', p: '90€/mois', st: 'ok', stl: 'Actif', bg: 'var(--red)', col: 'white' },
                      ].map((a) => (
                        <div key={a.n} style={{ background: 'var(--surface2)', border: '1px solid var(--border)', borderRadius: 12, padding: 14, display: 'flex', gap: 12, cursor: 'pointer' }} onClick={() => toast(`Accès au back-office ${a.n}`)}>
                          <div className="av" style={{ width: 40, height: 40, borderRadius: 12, background: a.bg, fontSize: 15, flexShrink: 0, color: a.col }}>{a.ini}</div>
                          <div style={{ flex: 1 }}><div style={{ fontSize: 13, fontWeight: 700 }}>{a.n}</div><div style={{ fontSize: 11, color: 'var(--muted)' }}>{a.s}</div></div>
                          <div style={{ textAlign: 'right' }}><div style={{ fontSize: 13, fontWeight: 800, color: 'var(--green)' }}>{a.p}</div><span className={`chip chip-${a.st}`} style={{ marginTop: 4 }}>{a.stl}</span></div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div>
                    <div className="card" style={{ marginBottom: 14 }}>
                      <div className="card-hdr"><div className="card-title">💰 MRR — {mrr}€</div></div>
                      <div className="card-body">
                        <div style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 8 }}>Objectif : 1 000€/mois</div>
                        <div className="prog-bar" style={{ marginBottom: 5 }}><div className="prog-fill" style={{ width: `${Math.min(100, (mrr / 1000) * 100)}%` }} /></div>
                        <div style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 14 }}>{Math.round((mrr / 1000) * 100)}% de l'objectif</div>
                        <div style={{ fontSize: 12 }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid var(--border)' }}><div style={{ display: 'flex', alignItems: 'center', gap: 6 }}><div style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--muted)' }} />Starter (20€)</div><span style={{ fontWeight: 700, color: 'var(--cyan)' }}>7 × 140€</span></div>
                          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid var(--border)' }}><div style={{ display: 'flex', alignItems: 'center', gap: 6 }}><div style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--cyan)' }} />Pro (45€)</div><span style={{ fontWeight: 700, color: 'var(--cyan)' }}>4 × 180€</span></div>
                          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0' }}><div style={{ display: 'flex', alignItems: 'center', gap: 6 }}><div style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--purple)' }} />Network (90€)</div><span style={{ fontWeight: 700, color: 'var(--cyan)' }}>1 × 90€</span></div>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-hdr"><div className="card-title">🔔 Alertes</div><span className="chip chip-err">3</span></div>
                      <div className="card-body" style={{ padding: 0 }}>
                        {[
                          ['🚨', 'Cie Théâtre — Stripe non connecté', "Impossible d'encaisser", 'Relancer'],
                          ['⚠️', 'Club Pétanque — Abonnement expiré', 'Depuis 5 jours', 'Facturer'],
                          ['📧', 'Asso Nantes — Email non vérifié', 'Depuis 3 jours', 'Renvoyer'],
                        ].map(([i, t, sub, btn], idx, arr) => (
                          <div key={idx} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, padding: '11px 16px', borderBottom: idx < arr.length - 1 ? '1px solid rgba(28,42,38,0.5)' : 'none' }}>
                            <div style={{ fontSize: 16 }}>{i}</div>
                            <div style={{ flex: 1 }}><div style={{ fontSize: 12, fontWeight: 700 }}>{t}</div><div style={{ fontSize: 10, color: 'var(--muted)' }}>{sub}</div></div>
                            <button className={`btn ${btn === 'Facturer' ? 'btn-primary' : 'btn-ghost'} btn-sm`} onClick={() => toast(`${btn} !`)}>{btn}</button>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {saSec === 'assos' && (
              <>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                    <button className="btn btn-ghost btn-sm">Toutes ({assoCount})</button>
                    <button className="btn btn-ghost btn-sm">🏛️ Pro</button>
                    <button className="btn btn-ghost btn-sm">⚽ Sport</button>
                    <button className="btn btn-ghost btn-sm">🎭 Culture</button>
                    <button className="btn btn-ghost btn-sm">🏥 Caritatif</button>
                  </div>
                  <button className="btn btn-primary btn-sm" onClick={onNewAsso}>➕ Nouvelle</button>
                </div>
                <div className="card"><div className="tw"><table>
                  <thead><tr><th>Association</th><th>Type</th><th>Membres</th><th>Plan</th><th>MRR</th><th>Stripe</th><th>Statut</th><th>Actions</th></tr></thead>
                  <tbody>
                    {[
                      ['R', 'REF Fugakwa', 'ref-fugakwa.plateforme-ref.fr', '🏛️ Réseau', 247, 'Pro', 'cyan', 45, '✓', 'ok', 'ok', 'Actif', 'var(--cyan)', '#060a09'],
                      ['GF', 'Rugby Figeac', 'rugby-figeac.plateforme-ref.fr', '⚽ Sport', 89, 'Starter', 'muted', 20, '✓', 'ok', 'ok', 'Actif', 'var(--blue)', 'white'],
                      ['CT', 'Cie Théâtre', 'theatre-soleil.plateforme-ref.fr', '🎭 Culture', 124, 'Starter', 'muted', 20, '⏳', 'warn', 'warn', 'Incomplet', 'var(--orange)', '#060a09'],
                      ['AS', 'Solidarité Cancer', 'solidarite-cancer.plateforme-ref.fr', '🏥 Caritatif', 312, 'Network', 'purple', 90, '✓', 'ok', 'ok', 'Actif', 'var(--red)', 'white'],
                    ].map(([ini, n, url, type, m, plan, planChip, mrrVal, stripe, stripeC, st, stl, bg, col]) => (
                      <tr key={n}>
                        <td><div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <div className="av" style={{ width: 26, height: 26, borderRadius: 7, background: bg, fontSize: 9, color: col }}>{ini}</div>
                          <div><div style={{ fontWeight: 600 }}>{n}</div><div style={{ fontSize: 10, color: 'var(--muted)' }}>{url}</div></div>
                        </div></td>
                        <td style={{ fontSize: 11 }}>{type}</td>
                        <td style={{ fontWeight: 700, color: 'var(--cyan)' }}>{m}</td>
                        <td><span className={`chip chip-${planChip}`} style={{ fontSize: 9 }}>{plan}</span></td>
                        <td style={{ fontWeight: 700, color: 'var(--green)' }}>{mrrVal}€</td>
                        <td><span className={`chip chip-${stripeC}`} style={{ fontSize: 9 }}>{stripe}</span></td>
                        <td><span className={`chip chip-${st}`} style={{ fontSize: 9 }}>{stl}</span></td>
                        <td><button className="btn btn-ghost btn-sm" onClick={() => toast(`Accès back-office ${n}`)}>Accéder</button></td>
                      </tr>
                    ))}
                  </tbody>
                </table></div></div>
              </>
            )}

            {saSec === 'revenus' && (
              <>
                <div className="g3" style={{ marginBottom: 14 }}>
                  <div className="kpi" style={{ borderRadius: 14 }}><div className="kpi-val" style={{ color: 'var(--cyan)' }}>{mrr}€</div><div className="kpi-lbl">MRR</div><div className="kpi-trend trend-up">↑ +90€ (+20%)</div></div>
                  <div className="kpi" style={{ borderRadius: 14 }}><div className="kpi-val" style={{ color: 'var(--blue)' }}>{mrr * 12}€</div><div className="kpi-lbl">ARR projeté</div><div className="kpi-trend" style={{ color: 'var(--muted)' }}>Obj. 12 000€/an</div></div>
                  <div className="kpi" style={{ borderRadius: 14 }}><div className="kpi-val" style={{ color: 'var(--green)' }}>+284€</div><div className="kpi-lbl">Commissions Stripe</div><div className="kpi-trend" style={{ color: 'var(--muted)' }}>2% sur cotisations</div></div>
                </div>
                <div className="card">
                  <div className="card-hdr"><div className="card-title">💳 Paiements SaaS</div><button className="btn btn-ghost btn-sm" onClick={() => toast('Export CSV généré')}>Exporter</button></div>
                  <div className="tw"><table>
                    <thead><tr><th>Association</th><th>Plan</th><th>Montant</th><th>Date</th><th>Statut</th></tr></thead>
                    <tbody>
                      <tr><td style={{ fontWeight: 600 }}>REF — Réseau Fugakwa</td><td>Pro</td><td style={{ fontWeight: 700, color: 'var(--green)' }}>45€</td><td style={{ color: 'var(--muted)' }}>1 juin 2024</td><td><span className="chip chip-ok">Payé</span></td></tr>
                      <tr><td style={{ fontWeight: 600 }}>Asso Solidarité Cancer</td><td>Network</td><td style={{ fontWeight: 700, color: 'var(--green)' }}>90€</td><td style={{ color: 'var(--muted)' }}>1 juin 2024</td><td><span className="chip chip-ok">Payé</span></td></tr>
                      <tr><td style={{ fontWeight: 600 }}>Club Pétanque Lyon</td><td>Starter</td><td style={{ fontWeight: 700, color: 'var(--red)' }}>20€</td><td style={{ color: 'var(--muted)' }}>Expiré</td><td><span className="chip chip-err">Échec</span></td></tr>
                    </tbody>
                  </table></div>
                </div>
              </>
            )}

            {saSec === 'alertes' && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {[
                  ['🚨', 'red', 'Cie Théâtre du Soleil — Stripe non connecté', "L'admin n'a pas configuré Stripe depuis 8 jours. Impossible d'encaisser les cotisations.", 'Relancer', 'ghost'],
                  ['💳', 'red', 'Club Pétanque Lyon — Abonnement SaaS expiré', "L'abonnement Starter (20€/mois) a expiré il y a 5 jours. Accès suspendu dans 2 jours.", 'Facturer', 'primary'],
                  ['📧', 'orange', 'Asso Sportive Nantes — Email non vérifié', "L'admin n'a pas confirmé son adresse email depuis 3 jours.", 'Renvoyer', 'ghost'],
                ].map(([i, color, t, sub, btn, btnVar], idx) => (
                  <div key={idx} style={{ display: 'flex', alignItems: 'flex-start', gap: 12, padding: 16, background: color === 'red' ? 'rgba(255,92,106,0.05)' : 'rgba(255,173,77,0.05)', border: `1px solid ${color === 'red' ? 'rgba(255,92,106,0.2)' : 'rgba(255,173,77,0.2)'}`, borderRadius: 12 }}>
                    <div style={{ fontSize: 20 }}>{i}</div>
                    <div style={{ flex: 1 }}><div style={{ fontSize: 13, fontWeight: 700 }}>{t}</div><div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 3 }}>{sub}</div></div>
                    <button className={`btn btn-${btnVar} btn-sm`} onClick={() => toast(`${btn} !`)}>{btn}</button>
                  </div>
                ))}
              </div>
            )}

            {saSec === 'ia' && (
              <div className="g2">
                <div className="card">
                  <div className="card-hdr"><div className="card-title">🤖 Agents actifs</div><span className="chip chip-ok">{Object.values(iaTog).filter(Boolean).length} actifs</span></div>
                  <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                    {[
                      ['relances', '📧', 'Agent Relances', '12 asso · 847 emails ce mois', 'var(--cyan-soft)'],
                      ['compta', '📊', 'Agent Comptable', '8 asso · Rapports auto mensuels', 'rgba(79,138,255,0.1)'],
                      ['asso', '🏛️', 'Agent Associatif', '12 asso · Coordination & AG', 'rgba(255,173,77,0.1)'],
                      ['com', '📣', 'Agent Communication', '6 asso · Posts réseaux planifiés', 'rgba(124,92,252,0.1)'],
                    ].map(([k, i, t, sub, bg]) => (
                      <div key={k} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: 12, background: 'var(--surface2)', borderRadius: 10 }}>
                        <div style={{ width: 34, height: 34, borderRadius: 9, background: bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16 }}>{i}</div>
                        <div style={{ flex: 1 }}><div style={{ fontSize: 13, fontWeight: 700 }}>{t}</div><div style={{ fontSize: 11, color: 'var(--muted)' }}>{sub}</div></div>
                        <button className={`toggle ${iaTog[k] ? 'on' : 'off'}`} onClick={() => setIaTog((s) => ({ ...s, [k]: !s[k] }))} />
                      </div>
                    ))}
                  </div>
                </div>
                <div className="card">
                  <div className="card-hdr"><div className="card-title">📈 Performance IA</div></div>
                  <div className="card-body">
                    <div style={{ fontSize: 12 }}>
                      {[['Emails relance envoyés', '847'], ['Taux d\'ouverture', '68%', 'var(--cyan)'], ['Renouvellements déclenchés', '124', 'var(--green)'], ['Rapports comptables générés', '24'], ['Temps économisé/mois', '120h', 'var(--cyan)']].map(([k, v, color], i, arr) => (
                        <div key={k} style={{ display: 'flex', justifyContent: 'space-between', padding: '7px 0', borderBottom: i < arr.length - 1 ? '1px solid var(--border)' : 'none' }}>
                          <span style={{ color: 'var(--muted)' }}>{k}</span><strong style={{ color: color || undefined }}>{v}</strong>
                        </div>
                      ))}
                    </div>
                    <div style={{ marginTop: 14, padding: 12, background: 'var(--cyan-soft)', border: '1px solid var(--cyan-border)', borderRadius: 9, fontSize: 12, color: 'var(--muted)' }}>
                      🤖 Modèle : <strong style={{ color: 'var(--text)' }}>Claude Sonnet 4.6 (Anthropic)</strong>
                    </div>
                    <div className="fg" style={{ marginTop: 14 }}><label className="fl">Clé API Anthropic</label><input className="fi" defaultValue="sk-ant-••••••••••••••••••••••••" style={{ fontFamily: 'monospace', fontSize: 11 }} /></div>
                    <button className="btn btn-primary btn-full" onClick={() => toast('Config IA sauvegardée !')}>Sauvegarder</button>
                  </div>
                </div>
              </div>
            )}

            {saSec === 'params' && (
              <div className="g2">
                <div className="card"><div className="card-hdr"><div className="card-title">⚙️ Paramètres plateforme</div></div><div className="card-body">
                  <div className="fg"><label className="fl">Nom de la plateforme</label><input className="fi" defaultValue="REF — Plateforme Associative" /></div>
                  <div className="fg"><label className="fl">Domaine principal</label><input className="fi" defaultValue="plateforme-ref.fr" /></div>
                  <div className="fg"><label className="fl">Email support</label><input className="fi" defaultValue="support@plateforme-ref.fr" type="email" /></div>
                  <div className="fg"><label className="fl">Commission par transaction</label><input className="fi" defaultValue="2% + 0,30€" style={{ fontFamily: 'monospace' }} /></div>
                  <button className="btn btn-primary btn-full" onClick={() => toast('Paramètres sauvegardés !')}>Sauvegarder</button>
                </div></div>
                <div className="card"><div className="card-hdr"><div className="card-title">📊 Métriques SaaS</div></div><div className="card-body">
                  <div style={{ fontSize: 12 }}>
                    {[['Taux de rétention', '91%', 'var(--green)'], ['Churn mensuel', '0,8%', 'var(--orange)'], ['LTV moyen', '540€'], ['Croissance mensuelle', '+20%', 'var(--green)'], ['NPS plateforme', '72', 'var(--cyan)']].map(([k, v, color], i, arr) => (
                      <div key={k} style={{ display: 'flex', justifyContent: 'space-between', padding: '7px 0', borderBottom: i < arr.length - 1 ? '1px solid var(--border)' : 'none' }}>
                        <span style={{ color: 'var(--muted)' }}>{k}</span><strong style={{ color: color || undefined }}>{v}</strong>
                      </div>
                    ))}
                  </div>
                </div></div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
